import {
    message,
    Spin,
    Row,
    Col,
    Select,
    //Form as FormInitial,
    Space,
    Checkbox,
    PageHeader,
    Tooltip,
    Modal,
    Alert
} from "antd";
import React, { Component } from "react";
import {
    Form,
    FormItem,
    InputNumberItem,
    SelectItem,
    round2Decimals,
    round6Decimals,
    dineroDisabledMask,
    ModalItem,
    DatePickerItem,
    InputItem,
    ButtonItem,
    ErrorItem,
    MensajeError,
    SwitchItem,
    DisponibilidadInsumoModal,
    HistorialInsumoClienteModal,
    DetalleInsumoModal,
    BusquedaAvanzadaInsumosModal,
} from "../../../../Components/Items";
import VentasForm from "../../../../Components/VentasForm";
import TabEntregaDireccion from "../../../../Components/TabEntregaDireccion";
import moment from "moment";
import axios from "axios";
import { connect } from "react-redux";
import {
    FileImageOutlined,
    StopOutlined,
    PlusOutlined,
    SwapOutlined,
    FileExcelOutlined,
    DownloadOutlined,
    UploadOutlined,
    SearchOutlined,
} from "@ant-design/icons";
import ModalCargarExcelInsumos from "../../../../Components/ModalCargarExcelInsumos";
import ModalFormatoRequerimiento from "../../../../Components/FormatoRequerimiento/ModalFormatoRequerimiento";
import TabFormatoRequerimiento from "../../../../Components/FormatoRequerimiento/TabFormatoRequerimiento";
import {
    descargarFormatoRequerimiento,
    datosFormatoDesdeCotizacion,
    hayDatosFormatoRequerimiento,
    formatoRequerimientoParaGuardar,
} from "../../../../Components/FormatoRequerimiento/formatoRequerimientoExcel";
import {
    construirFilasInsumosDesdeExcel,
    insumosNuevosParaCatalogo,
    combinarFilasInsumos,
    payloadInventarioBulk,
    aplicarInventarioBulk,
} from "../../../../Components/cargarInsumosExcel.utils";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ElegirTipoDeCliente from "../../Clientes/ElegirTipoDeCliente/ElegirTipoDeCliente";
import cotizacionPdf from "../../../../Pdf/cotizacionPdf";
import MandarCorreoCotizacion from "../MandarCorreoCotizacion/MandarCorreoCotizacion";
import AgregarCliente from "../../Ventas/AgregarVenta/AgregarCliente/AgregarCliente";
import AgregarCanalVenta from "../../CanalesVenta/AgregarCanalVenta/AgregarCanalVenta";
import ElegirLeyenda from "../../Ventas/ElegirLeyenda/ElegirLeyenda";
import ElegirLotes from "../../LotesCaducidades/ElegirLotes/ElegirLotes";
import ElegirAgrupaciones from "../../Agrupaciones/ElegirAgrupaciones/ElegirAgrupaciones";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import ElegirObservaciones from "../../Ventas/ElegirObservaciones/ElegirObservaciones";
import VerInsumo from "../../Ventas/AgregarVenta/VerInsumo/VerInsumo";
import ModalCargarImagen from "../ModalCargarImagen.js/ModalCargarImagen";
import PaqueteControls from "../../../../Components/PaqueteControls";
import { FilaInsumoCotizacion } from "../../../../Components/FilaInsumosCotizacion";
import ModalAutorizacion from "../../../../Components/AutorizacionRapida/ModalAutorizacion";
import BotonAutorizacion from "../../../../Components/AutorizacionRapida/BotonAutorizacion";
import { PERMISOS_AUTORIZABLES } from "../../../../Utils/autorizaciones";
import { crearReglasPrecio } from "../../../../Utils/reglasPrecioDocumento";
import {
    aplicarDescuentoBaseAFila,
    normalizarDescuentoFila,
    sincronizarDescuentoFila,
} from "../../../../Utils/descuentoEscuela";
import {  reordenarAlDesagrupar, formatearPaquetesParaGuardar } from "../../../../Utils/Paquetes.utils";
import AgregarCirugia from "../../Cirugias/AgregarCirugia/AgregarCirugia";
import AgregarDoctor from "../../Doctores/AgregarDoctor/AgregarDoctor";
import AgregarPaciente from "../../Pacientes/AgregarPaciente/AgregarPaciente";
import { refrescarCatalogoInsumosCliente } from "../../../../Components/catalogoInsumosCliente";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
//const { TabPane } = Tabs;

class AgregarCotizacion extends Component {
    formRef = React.createRef();
    contadoAnterior = 1;
    precioIdAnterior = undefined;
    // Reglas de lista de precios: aviso en vivo, bloqueo al guardar y descuento
    // minimo automatico. Compartido con Ventas, Pedidos y Embarques.
    reglas = crearReglasPrecio(this, {
        modulo: "COTIZACION",
        recalcularTotales: (insumos) => this.recalcularInsumosEnBatch(insumos),
    });
    usarPrecioClienteAnterior = true;
    state = {
        loading: false,
        // Autorizaciones rápidas: clave "campo:index" → {autorizacionId, tokenConsumo}
        autorizacionesActivas: {},
        modalAutorizacion: null, // {visible, permisoId, clave, contexto}
        // Reglas de la lista de precios para este cliente; null = nada que revisar.
        contextoReglas: null,
        // Violaciones de rango por renglón: index → {campo, motivo, limite, valor}
        fueraDeRango: {},
        objetoClientes: null,
        todasClientes: [],
        objetoProyectos: null,
        todasProyectos: null,
        objetoPrecios: null,
        todasPrecios: null,
        objetoInsumos: null,
        todasInsumos: [],
        modalCargarExcelVisible: false,
        modalFormatoRequerimientoVisible: false,
        objetoUsosDeCFDI: null,
        todasUsosDeCFDI: null,
        objetoBancos: null,
        todasBancos: null,
        objetoUsuarios: null,
        todasUsuarios: null,
        objetoMonedas: null,
        todasMonedas: null,
        impuestos: [],
        modalConfirmacion: false,
        modalCorreo: false,
        modalCorreoId: null,
        modalElegirTipoDeCliente: false,
        modalElegirTipoDeClienteNombre: null,
        modalElegirTipoDeClienteId: null,
        valuesForm: null,
        entregarInsumos: false,
        totalPagar: 0,
        venderSinInventario: false,
        modalAgregar: false,
        objetoDoctores: null,
        todasDoctores: null,
        objetoPacientes: null,
        todasPacientes: null,
        modalLeyenda: false,
        modalLeyendaIndex: null,
        modalLeyendaLeyenda: null,
        modalLeyendaLeyendasPasadas: null,
        modalObservaciones: false,
        modalObservacionesIndex: null,
        modalObservacionesObservaciones: null,
        modalObservacionesObservacionesPasadas: null,
        modalObservacionesObservacionesXml: null,
        modalVerInsumo: false,
        modalVerInsumoId: null,
        modalVerInsumoPrecioId: null,
        modalVerInsumoIndex: 0,
        modalVerInsumoTipoDeCambio: 1,
        direccionesCliente: [],
        objetoDireccionesCliente: null,
        direccionEntregaData: null,
        todasPaises: [],
        todasEstado: [],
        todasMunicipios: [],
        todasColonias: [],
        objetoPaises: null,
        objetoEstados: null,
        objetoMunicipios: null,
        objetoColonias: null,
        loadingEntrega: false,
        addendaMabe: false,
        loadingPlantasEntrega: false,
        leyenda: null,
        leyendaActiva: false,
        mostrarImprimirImagen: false,
        opcionImagen: null,
        modalImagenVisible: false,
        indiceFilaImagen: null,
        modalVistaPreviaVisible: false,
        vistaPreviaUrl: null,
        //Datos para paquetes
        configuracionPaquetes :false, 
        mostrarDatosPaquete: false,
        paquetes : [],
        indicesSeleccionadosPaquete: [],
        nombrePaquete: '',
        paqueteEditadoId : null,
        showFormaDePagoCard: false,
        tiposDescuento: {},
        docObligatorio : false,
        modalAgregarCirugia : false, 
        modalAgregarDoctor : false, 
        modalAgregarPaciente : false,
        cantidadDefault : false,
        modoReordenar: false,
        loadingTabla: false,
        clienteIdActual: null,
        nombreClienteActual: null,
        objetoCanalesVenta: null,
        todasCanalesVenta: [],
        modalAgregarCanal: false,
        modalDisponibilidadVisible: false,
        insumoSeleccionadoDisponibilidad: { id: null, nombre: '' },
        modalHistorialClienteVisible: false,
        insumoSeleccionadoHistorial: { id: null, nombre: '', clienteId: null, index: 0 },
        modalDetalleInsumoVisible: false,
        insumoSeleccionadoDetalle: { id: null, nombre: '' },
        modalBusquedaAvanzadaVisible: false,
        contextoBusquedaAvanzada: {},
        quitarImpuestos: false,
        preCotizacionOrigen: null,
    };
     componentDidMount() {
        this.consultarTodo();
        if (this.preCotizacionIdOrigen) this.consultarPreCotizacionOrigen();
    }

    // Llega desde "Crear Cotización" de una pre cotización de ingeniería: al guardar, las
    // dos quedan ligadas (el backend escribe el lado de la pre cotización).
    get preCotizacionIdOrigen() {
        return this.props.location?.state?.preCotizacionId || null;
    }

    // El cliente de la pre cotización es texto libre y no se puede convertir en un cliente
    // del catálogo: solo se muestra en el aviso y el usuario lo elige a mano. Sus "notas
    // para la cotización" sí se copian a las Observaciones (las que se imprimen), salvo que
    // el usuario ya haya escrito algo ahí.
    consultarPreCotizacionOrigen() {
        axios
            .post(
                "preCotizacionIngenieria/datosPreCotizacion",
                { empresaId: this.props.empresaId, preCotizacionId: this.preCotizacionIdOrigen },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success !== 2) return;
                const notasCotizacion = (res.data.notasCotizacion || "").trim();
                const observacionesActuales = (this.formRef.current?.getFieldValue("observaciones") || "").trim();
                if (notasCotizacion && !observacionesActuales) {
                    this.formRef.current?.setFieldsValue({ observaciones: notasCotizacion });
                }
                // El setState repinta VentasForm, que lee las observaciones del form al render.
                this.setState({ preCotizacionOrigen: res.data });
            })
            .catch(() => {});
    }

    abrirDisponibilidad = (insumoId, nombre, proyectoId) => {
        this.setState({ modalDisponibilidadVisible: true, insumoSeleccionadoDisponibilidad: { id: insumoId, nombre, proyectoId } });
    }

    cerrarDisponibilidad = () => {
        this.setState({ modalDisponibilidadVisible: false });
    }

    abrirDetalleInsumo = (insumoId, nombre) => {
        if (!insumoId) return;
        this.setState({ modalDetalleInsumoVisible: true, insumoSeleccionadoDetalle: { id: insumoId, nombre } });
    }

    cerrarDetalleInsumo = () => {
        this.setState({ modalDetalleInsumoVisible: false });
    }

    // Boton "Busqueda avanzada" junto a "Agregar Insumo". El contexto es una foto del documento al
    // abrir; el modal lo manda igual que el SelectInsumosItem del renglon.
    abrirBusquedaAvanzada = () => {
        const form = this.formRef.current;
        if (!form) return;
        this.setState({
            modalBusquedaAvanzadaVisible: true,
            contextoBusquedaAvanzada: {
                clienteId: form.getFieldValue("clienteId"),
                usarPrecioCliente: form.getFieldValue("usarPrecioCliente"),
                precioId: form.getFieldValue("precioId"),
                proyectoId: form.getFieldValue("proyectoId"),
            },
        });
    }

    cerrarBusquedaAvanzada = () => {
        this.setState({ modalBusquedaAvanzadaVisible: false });
    }

    // Llena el primer renglon vacio o agrega uno, y corre el mismo onChangeInsumoProyecto que el
    // select del renglon. El modal espera esta promesa antes de dejar agregar otro: el handler
    // reescribe el arreglo completo y dos altas a la vez se pisarian. Vacio = sin insumo ni precio
    // ("Agregar Insumo" con cantidadDefault ya crea renglones con cantidad 1) y fuera de un
    // paquete, para que el insumo no se meta callado en uno. El proyecto va explicito porque
    // el initialValue del renglon nuevo aun no se aplica cuando corre el handler.
    agregarInsumoDesdeBusqueda = async ({ insumo, cantidad }) => {
        const form = this.formRef.current;
        if (!form) return;
        const insumos = [...(form.getFieldValue("insumos") || [])];
        const proyectoId = form.getFieldValue("proyectoId");
        const insumoId = insumo._id?.toString();
        let indice = insumos.findIndex((fila) => !fila?.insumoId && !fila?.precioUnitario && !fila?._paqueteId);
        if (indice === -1) {
            indice = insumos.length;
            insumos.push({ insumoId, cantidad, proyectoId });
        } else {
            insumos[indice] = { ...insumos[indice], insumoId, cantidad, proyectoId: insumos[indice]?.proyectoId || proyectoId };
        }
        form.setFieldsValue({ insumos });
        await this.onChangeInsumoProyecto(insumoId, indice, "insumo", false, insumo);
    }

    // Clic derecho en la misma celda donde el doble clic abre Disponibilidad. Lo llama
    // FilaInsumosCotizacion a traves del bag `funciones`.
    abrirHistorialCliente = (insumoId, nombre, index) => {
        if (!insumoId) return message.warning("Primero selecciona un insumo en el renglón");
        const clienteId = this.formRef.current?.getFieldValue("clienteId");
        if (!clienteId) return message.warning("Primero selecciona un cliente para ver su historial");
        this.setState({
            modalHistorialClienteVisible: true,
            insumoSeleccionadoHistorial: { id: insumoId, nombre, clienteId, index },
        });
    }

    // Mismo contrato que cerrarVerInsumo: si el modal devuelve un precio, se escribe en el
    // renglón y se dispara el recálculo canónico.
    // Espeja el estaBloqueado("precioUnitario") de FilaInsumosCotizacion, que es quien de verdad
    // gobierna el input de PU en esta pantalla. Conserva el trato especial de insumoCambio,
    // que el estaBloqueado de la pagina no conoce.
    historialPrecioBloqueado = () => {
        const { id, index } = this.state.insumoSeleccionadoHistorial;
        const insumoOriginal = this.state.todasInsumos?.find((i) => i._id === id);
        if (insumoOriginal?.insumoCambio) return false;
        return this.estaBloqueado("precioUnitario", index);
    };

    cerrarHistorialCliente = async (precio) => {
        const index = this.state.insumoSeleccionadoHistorial.index;
        if (precio && precio > 0) {
            const insumos = await this.formRef.current.getFieldValue('insumos');
            // El precio del historial viene NETO (ya traia su descuento dentro), asi que se limpia el
            // descuento del renglon: si no, se descontaria dos veces y lo cobrado no seria lo que
            // mostraba el modal.
            const teniaDescuento = !!insumos[index]?.descuento || !!insumos[index]?.descuentoCantidad;
            insumos[index].precioUnitario = precio;
            insumos[index].descuento = 0;
            insumos[index].descuentoCantidad = 0;
            if (this.props.escuela) {
                insumos[index].descuentoBase = 0;
                insumos[index].descuentoAdicional = 0;
            }
            await this.formRef.current.setFieldsValue({ insumos });
            this.onChangePrecioCantidadDescuento(undefined, index);
            if (teniaDescuento) message.info("Se limpió el descuento del renglón: el precio del historial ya viene neto");
        }
        this.setState({ modalHistorialClienteVisible: false });
    }

    abrirAgregarCliente = () => {
        this.setState({ modalAgregar: true });
    };

    cerrarAgregarCliente = (id) => {
        this.setState({ modalAgregar: false });
        this.consultarTodo();
        if (id) {
            this.formRef.current.setFieldsValue({ clienteId: id })
        }
    };

    abrirAgregarCanal = () => {
        this.setState({ modalAgregarCanal: true });
    };

    cerrarAgregarCanal = (id) => {
        this.setState({ modalAgregarCanal: false });
        this.consultarTodo();
        if (id) {
            this.formRef.current.setFieldsValue({ canalDeVentaId: id });
        }
    };

    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "cotizaciones/selectDatosParaCotizacion",
                { empresaId: this.props.empresaId, cotizacionId: this.props?.location?.state?.duplicar },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    this.setState({
                        todasProyectos: res.data.proyectos,
                        todasPrecios: res.data.precios,
                        todasUsosDeCFDI: res.data.usosDeCFDI,
                        todasUsuarios: res.data.usuariosEmpresa,
                        todasMonedas: res.data.monedas,
                        venderSinInventario: res.data.venderSinInventario,
                        ponerVendedor: res.data.ponerVendedor,
                        ponerCanal: res.data.ponerCanal,
                        ponerMetodoDePago: res.data.ponerMetodoDePago,
                        mostrarImprimirImagen: res.data.imprimirImagenes,
                        configuracionPaquetes : res.data?.paquetes,
                        docObligatorio: res.data.docObligatorio,
                        cantidadDefault : res.data.cantidadDefault,
                        todasCanalesVenta: res.data.canalesVenta,
                        objetoProyectos: res.data.proyectos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoPrecios: res.data.precios.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoUsosDeCFDI: res.data.usosDeCFDI.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_UsoCFDI + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),
                        objetoUsuarios: res.data.usuariosEmpresa.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre +
                                        " " +
                                        value.apellidoPaterno +
                                        " " +
                                        value.apellidoMaterno}
                                </Option>
                            );
                        }),
                        objetoMonedas: res.data.monedas.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviacion}
                                </Option>
                            );
                        }),
                        objetoCanalesVenta: res.data.canalesVenta?.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }) || null,
                    });

                    if (res.data?.deshabilitarBanco) {
                        this.formRef.current.setFieldsValue({ deshabilitarBanco: res.data?.deshabilitarBanco });
                    }

                    const diasPredeterminados = res.data?.diasPredetVen; 

                    const esAutomatico = res.data?.fechaVigenciaAutomatica;
                    const fechaVigenciaValor = esAutomatico ? moment().add(diasPredeterminados, 'days') : null;
                    this.formRef.current.setFieldsValue({
                        fechaVigencia: fechaVigenciaValor
                    });
                }
            });

        if (this.props.equipoMedico) {

            await axios
                .post(
                    "ventas/selectDatosParaEquipoMedico",
                    { empresaId: this.props.empresaId },
                    {
                        headers: this.props.headersToken,
                    }
                )
                .then((res) => {
                    if (res.data.success === 2) {
                        this.setState({
                            todasDoctores: res.data.doctores,
                            todasPacientes: res.data.pacientes,
                            todasCirugias: res.data.cirugias,
                            objetoDoctores: res.data.doctores.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                            objetoPacientes: res.data.pacientes.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                            objetoCirugias: res.data.cirugias.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                        });
                    } else {
                        message.error('No se encontraron datos de equipo medico')
                    }
                });

        }

        if (this.props.location?.state?.duplicar) {
    
            const idDuplicar = this.props.location.state.duplicar;
    
            await axios.post("cotizaciones/datosCotizacion",
            { cotizacionId: idDuplicar, empresaId: this.props.empresaId },
            { headers: this.props.headersToken }
            ).then(async (res) => {
            if (res.data.status !== 404) {
    
                const responseCliente = await axios.post("clientes/buscarCliente", {
                clienteId: res.data.clienteId,
                empresaId: this.props.empresaId
                }, { headers: this.props.headersToken })
    
                if (responseCliente.data.success === 2) {
                await this.setState({
                    todasClientes: [responseCliente.data.cliente],
                    direccionesCliente: responseCliente.data.cliente.direcciones,
                    objetoDireccionesCliente: responseCliente.data.cliente.direcciones.map((value) => {
                    return (
                        <Option value={value._id} key={value._id}>
                        {(value.calle || "Sin calle") + ' ' + (value.numeroCalle || "Sin número") + (value.numeroInterior ? ' Int. ' + value.numeroInterior : '') + ', ' + (value.colonia || "Sin colonia")}
                        </Option>
                    )
                    }),
                })
                } else {
                return message.error('No se pudo obtener el cliente de la cotización a duplicar')
                }
    
                const insumosAgregarTodos = res.data.insumosCatalogo || [];

                if (insumosAgregarTodos.length === 0 && res.data?.insumos?.length > 0) {
                    return message.error('No se pudieron obtener todos los insumos de la cotización a duplicar');
                }

                const insumos = res.data.insumos.map((insumo) => {
                    const divisor = insumo.cantidad > 0 ? insumo.cantidad : 1;
                    const precioUnitarioConImpuestos = insumo.precioUnitario + (insumo.impuestos / divisor);
                    return {
                        ...insumo,
                        precioUnitarioConImpuestos,
                    };
                });

                await this.setState({
                todasInsumos: insumosAgregarTodos,
                ubicacionesEnvio: Array.isArray(res.data.ubicacionesEnvio) ? res.data.ubicacionesEnvio.map(value => {
                    return { ...value, _id: undefined }
                }) : undefined,
                mercanciasEnvio: Array.isArray(res.data.mercanciasEnvio) ? res.data.mercanciasEnvio.map(value => {
                    return { ...value, _id: undefined }
                }) : undefined,
                })
    
                this.onChangeContado(res.data.contado, true)


                const tiposDescuentoIniciales = {};
                (res.data.insumos || []).forEach((insumo, index) => {
                if (insumo.descuentoCantidad && insumo.descuentoCantidad > 0) {
                    tiposDescuentoIniciales[index] = 'cantidad';
                } else {
                    tiposDescuentoIniciales[index] = 'porcentaje';
                }
                });
    
                this.setState({ tiposDescuento: tiposDescuentoIniciales });
    
                const insumosBulkPayload = insumos.map((insumo, index) => {
                    const insumoIdString = insumo.insumoId?._id || insumo.insumoId;
                    const insumoOriginal = insumosAgregarTodos.find(
                        (i) => i._id === insumo.insumoId || i._id === insumo.insumoId?._id
                    );
                    return {
                        index: index,
                        insumoId: insumoIdString,
                        proyectoId: insumo.proyectoId || res.data.proyectoId,
                        inventariable: insumoOriginal?.inventariable,
                        noPrincipal: insumoOriginal?.noPrincipal,
                        insumoCompuesto: insumoOriginal?.insumoCompuesto,
                    };
                });

                try {
                    const resInventarios = await axios.post("inventarios/inventarioInsumoProyectoBulk", {
                        empresaId: this.props.empresaId,
                        proyectoId: res.data.proyectoId,
                        insumos: insumosBulkPayload
                    }, { headers: this.props.headersToken });

                    if (resInventarios.data && resInventarios.data.results) {
                        resInventarios.data.results.forEach(resItem => {
                            if (insumos[resItem.index]) {
                                insumos[resItem.index].cantidadProyecto =
                                    resItem.cantidad !== null ? resItem.cantidad : "No inventariable";
                            }
                        });
                    }
                } catch (error) {
                    console.error("Error al consultar inventario", error);
                }

                await this.formRef.current.setFieldsValue({
                factura: res.data.factura ? 1 : 2,
                contado: res.data.contado,
                clienteId: res.data.clienteId,
                vendedorId: res.data.vendedorId,
                monedaId: res.data.monedaId,
                tipoDeCambio: res.data.tipoDeCambio,
                doctorId: res.data.doctorId,
                pacienteId: res.data.pacienteId,
                cirugiaId: res.data.cirugiaId,
                bancoId: res.data.bancoId,
                cuentasXC: res.data.cuentasXC,
                proyectoId: res.data.proyectoId,
                formaPagoId: res.data.formaPagoId,
                precioId: res.data.precioId,
                diasCredito: res.data.diasCredito,
                usoDeCfdiId: res.data.usoDeCfdiId,
                ordenDeCompra: res.data.ordenDeCompra,
                usarPrecioCliente: res.data.usarPrecioCliente !== false,
                usarEmpresaAlterna: res.data.usarEmpresaAlterna !== false,
                insumos: insumos,
                proyectoTransporteId: res.data.proyectoTransporteId,
                remolquesIds: res.data.remolquesIds,
                choferesIds: res.data.choferesIds,
                tranporteInt: res.data.tranporteInt,
                registroISTMO: res.data.registroISTMO,
                ubicacionPoloOrigenId: res.data.ubicacionPoloOrigenId,
                ubicacionPoloDestinoId: res.data.ubicacionPoloDestinoId
                })
                this.contadoAnterior = res.data.contado;
                this.precioIdAnterior = res.data.precioId;

                this.recalcularInsumosEnBatch(insumos)
    
            } else {
                message.error('No se pudo obtener la cotización a duplicar')
            }
            }).catch((err) => {
            message.error('Error al obtener la cotización a duplicar')
            })
    
        }

        if (this.props.location?.state?.planBiwo) {
            await this.precargarPlanBiwo(this.props.location.state.planBiwo);
        }

        this.setState({ loading: false });

        // Al montar: una cotizacion duplicada ya trae cliente y lista, y sin esto
        // se quedaria sin reglas hasta que el usuario tocara uno de los dos.
        this.reglas.consultarContexto();
    }

    precargarPlanBiwo = async (plan) => {
        const responseCliente = await axios.post("clientes/buscarCliente", { clienteId: plan.clienteId, empresaId: this.props.empresaId }, { headers: this.props.headersToken });
        if (responseCliente.data.success !== 2) return message.error("No se pudo obtener el cliente de la cotización");
        const cliente = responseCliente.data.cliente;
        await this.setState({
            todasClientes: [cliente],
            direccionesCliente: cliente.direcciones,
            objetoDireccionesCliente: cliente.direcciones.map((value) => (
                <Option value={value._id} key={value._id}>
                    {(value.calle || "Sin calle") + " " + (value.numeroCalle || "Sin número") + (value.numeroInterior ? " Int. " + value.numeroInterior : "") + ", " + (value.colonia || "Sin colonia")}
                </Option>
            )),
            todasInsumos: plan.insumosCatalogo,
            tiposDescuento: Object.fromEntries(plan.lineas.map((_, index) => [index, "porcentaje"])),
        });
        const insumos = plan.lineas.map((linea) => ({ ...linea, cantidadProyecto: "No inventariable" }));
        const vendedorValido = (this.state.todasUsuarios || []).some((u) => String(u._id) === String(plan.vendedorId));
        await this.formRef.current.setFieldsValue({
            clienteId: plan.clienteId,
            ...(vendedorValido ? { vendedorId: plan.vendedorId } : {}),
            proyectoId: plan.proyectoId,
            formaPagoId: plan.formaPagoId,
            precioId: plan.precioId,
            usoDeCfdiId: plan.usoDeCfdiId,
            insumos,
        });
        this.precioIdAnterior = plan.precioId;
        this.recalcularInsumosEnBatch(insumos);
    };

    estaBloqueado = (campo, index) => {
        const permisoProp = {
            precioUnitario: "permisoModificarPrecioUnitario",
            descuento: "permisoModificarDescuento",
            listaPrecios: "permisoModificarListaPrecios",
        }[campo];
        const clave = index !== undefined && index !== null ? `${campo}:${index}` : campo;
        return !this.props[permisoProp] && !this.state.autorizacionesActivas[clave]?.accesoLibre;
    };

    abrirModalAutorizacion = (campo, index, reanudarGuardado) => {
        const definicion = PERMISOS_AUTORIZABLES[campo];
        if (!definicion) return;
        if (index !== undefined && index !== null) {
            const insumos = this.formRef.current?.getFieldValue("insumos") || [];
            const item = insumos[index] || {};
            const insumoOriginal = this.state.todasInsumos.find(
                (i) => i._id === item.insumoId
            );
            const insumoNombre = insumoOriginal?.nombre || insumoOriginal?.descripcion || "";
            const valorActual =
                campo === "descuento"
                    ? item.descuento ?? item.descuentoCantidad ?? 0
                    : item.precioUnitario;
            this.setState({
                modalAutorizacion: {
                    visible: true,
                    permisoId: definicion.permisoId,
                    campo,
                    index,
                    clave: `${campo}:${index}`,
                    contexto: {
                        modulo: "COTIZACION",
                        campo,
                        insumoId: item.insumoId,
                        insumoNombre,
                        valorActual,
                        tipoDescuento: campo === "descuento" ? this.state.tiposDescuento[index] : undefined,
                        descripcion: `${definicion.etiqueta}${insumoNombre ? ` — ${insumoNombre}` : ""}`,
                    },
                    reanudarGuardado,
                },
            });
        } else if (campo === "listaPrecios") {
            const clienteId = this.formRef.current?.getFieldValue("clienteId");
            const cliente = this.state.todasClientes?.find((c) => c._id === clienteId);
            const clienteNombre = cliente
                ? cliente.persona
                    ? cliente.razonSocial || ""
                    : `${cliente.nombre || ""} ${cliente.apellidoPaterno || ""} ${cliente.apellidoMaterno || ""}`.trim()
                : "";
            const precioIdActual = this.formRef.current?.getFieldValue("precioId");
            const precioActual = this.state.todasPrecios?.find((p) => p._id === precioIdActual);
            this.setState({
                modalAutorizacion: {
                    visible: true,
                    permisoId: definicion.permisoId,
                    campo,
                    clave: campo,
                    contexto: {
                        modulo: "COTIZACION",
                        campo,
                        valorActual: precioActual?.nombre || undefined,
                        descripcion: `${definicion.etiqueta}${clienteNombre ? ` — ${clienteNombre}` : ""}`,
                    },
                    reanudarGuardado,
                },
            });
        }
    };

    onAutorizado = async (datos) => {
        const { modalAutorizacion } = this.state;
        if (!modalAutorizacion) return;
        const { campo, index } = modalAutorizacion;
        if (!datos.accesoLibre && datos.valorSolicitado !== undefined && datos.valorSolicitado !== null) {
            if (index !== undefined && index !== null) {
                const insumos = this.formRef.current.getFieldValue("insumos") || [];
                const campoDestino =
                    campo === "descuento"
                        ? (this.state.tiposDescuento[index] === "cantidad"
                            ? "descuentoCantidad"
                            : (this.props.escuela ? "descuentoAdicional" : "descuento"))
                        : campo;
                insumos[index] = { ...insumos[index], [campoDestino]: datos.valorSolicitado };
                if (this.props.escuela && campo === "descuento") sincronizarDescuentoFila(insumos[index]);
                this.formRef.current.setFieldsValue({ insumos });
            } else if (campo === "listaPrecios") {
                this.formRef.current.setFieldsValue({ precioId: datos.valorSolicitado });
                this.precioIdAnterior = datos.valorSolicitado;
                const insumos = this.formRef.current.getFieldValue("insumos");
                if (insumos?.length > 0) {
                    message.info("Se actualizaron los precios de los insumos según la nueva lista de precios autorizada.");
                    this.recalcularPreciosTodosLosInsumos(datos.valorSolicitado);
                }
            }
        }
        this.setState(
            {
                autorizacionesActivas: {
                    ...this.state.autorizacionesActivas,
                    [modalAutorizacion.clave]: datos,
                },
                modalAutorizacion: null,
            },
            () => {
                // Si la autorizacion venia del bloqueo al guardar, se reanuda ahora
                // que el campo ya esta cubierto. Se llama al onFinish real, NO al
                // modal de confirmacion: el usuario ya confirmo una vez.
                if (!modalAutorizacion.reanudarGuardado) return;
                if (this.reglas.primeraSinAutorizar()) return;
                this.onFinish(this.state.valuesForm);
            }
        );
    };

    autorizacionesParaPayload = () =>
        Object.values(this.state.autorizacionesActivas).map((a) => ({
            autorizacionId: a.autorizacionId,
            tokenConsumo: a.tokenConsumo,
        }));

    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        if (!values.insumos || values.insumos?.length === 0)
            return message.warning("Agregue insumos para agregar la cotización");

        // Rangos de la lista de precios. Si algo se sale y ese campo no esta
        // autorizado, se pide la autorizacion y se reanuda desde onAutorizado.
        // El backend valida lo mismo.
        const violacion = this.reglas.primeraSinAutorizar();
        if (violacion) {
            message.warning(violacion.motivo);
            this.abrirModalAutorizacion(violacion.campo, violacion.index, true);
            return;
        }
        this.setState({ loading: true });
        let insumos = values.insumos;
        let total = 0;
        let subtotal = 0;
        let arrayImpuestos = [];
        let arrayRetenciones = [];
        let cuentasCliente = 0;
        insumos.map((value) => {
            total += value.subtotal;
            subtotal += value.subtotal;
            value.arrayImpuestos.map((valueImpuestos) => {
                let index = arrayImpuestos.findIndex(
                    (valueImpuestosAnterios) =>
                        valueImpuestosAnterios.descripcionFactura ===
                        valueImpuestos.descripcionFactura
                        &&
                        valueImpuestosAnterios.tasaCuota ===
                        valueImpuestos.tasaCuota
                        &&
                        valueImpuestosAnterios.impuesto ===
                        valueImpuestos.impuesto
                );
                if (index !== -1) {
                    let newItem = {
                        totalImpuestos:
                            arrayImpuestos[index].totalImpuestos +
                            valueImpuestos.totalImpuestos,
                        baseImpuesto:
                            arrayImpuestos[index].baseImpuesto +
                            valueImpuestos.baseImpuesto,
                        descripcionFactura:
                            valueImpuestos.descripcionFactura,
                        tasaCuota:
                            valueImpuestos.tasaCuota,
                        impuesto:
                            valueImpuestos.impuesto,
                        montoImpuesto:
                            valueImpuestos.montoImpuesto,
                        local: valueImpuestos.local,
                    };
                    arrayImpuestos.splice(index, 1, newItem);
                } else {
                    arrayImpuestos.push({
                        tasaCuota: valueImpuestos.tasaCuota,
                        local: valueImpuestos.local,
                        impuesto: valueImpuestos.impuesto,
                        montoImpuesto: valueImpuestos.montoImpuesto,
                        baseImpuesto: valueImpuestos.baseImpuesto,
                        descripcionFactura: valueImpuestos.descripcionFactura,
                        totalImpuestos: valueImpuestos.totalImpuestos,
                    });
                }
                return null;
            });
            if (value.arrayRetenciones) {
                value.arrayRetenciones.map((valueRetenciones) => {
                    let index = arrayRetenciones.findIndex(
                        (valueRetencionesAnterios) =>
                            valueRetencionesAnterios.descripcionFactura ===
                            valueRetenciones.descripcionFactura
                            &&
                            valueRetencionesAnterios.tasaCuota ===
                            valueRetenciones.tasaCuota
                            &&
                            valueRetencionesAnterios.impuesto ===
                            valueRetenciones.impuesto
                    );
                    cuentasCliente += round2Decimals(valueRetenciones.totalRetenciones);
                    if (index !== -1) {
                        let newItem = {
                            totalRetenciones:
                                arrayRetenciones[index].totalRetenciones +
                                valueRetenciones.totalRetenciones,
                            baseRetencion:
                                arrayRetenciones[index].baseRetencion +
                                valueRetenciones.baseRetencion,
                            descripcionFactura:
                                valueRetenciones.descripcionFactura,
                            tasaCuota:
                                valueRetenciones.tasaCuota,
                            impuesto:
                                valueRetenciones.impuesto,
                            montoRetencion:
                                valueRetenciones.montoRetencion,
                            local: valueRetenciones.local,
                        };
                        arrayRetenciones.splice(index, 1, newItem);
                    } else {
                        arrayRetenciones.push({
                            tasaCuota: valueRetenciones.tasaCuota,
                            impuesto: valueRetenciones.impuesto,
                            montoRetencion: valueRetenciones.montoRetencion,
                            baseRetencion: valueRetenciones.baseRetencion,
                            local: valueRetenciones.local,
                            descripcionFactura: valueRetenciones.descripcionFactura,
                            totalRetenciones: valueRetenciones.totalRetenciones,
                        });
                    }
                    return null;
                });
            }
            return null;
        });
        arrayImpuestos = arrayImpuestos.map(valueImpuesto => {
            total += round2Decimals(valueImpuesto.totalImpuestos)
            return {
                ...valueImpuesto,
                totalImpuestos: round2Decimals(valueImpuesto.totalImpuestos),
            }
        })


        const paquetesParaGuardar = formatearPaquetesParaGuardar(
             this.state.paquetes || [], 
             values.insumos
         );

        axios
            .post(
                "cotizaciones/agregarCotizacion",
                {
                    ...values,
                    empresaId: this.props.empresaId,
                    total,
                    subtotal,
                    cuentasCliente: round2Decimals(cuentasCliente),
                    totalPagar: round2Decimals(total - cuentasCliente),
                    arrayImpuestos,
                    arrayRetenciones,
                    paquetes: paquetesParaGuardar,
                    autorizaciones: this.autorizacionesParaPayload(),
                    preCotizacionIngenieriaId: this.preCotizacionIdOrigen || undefined,
                    formatoRequerimiento: this.props.formatoRequerimientoCotizaciones
                        ? formatoRequerimientoParaGuardar(values.formatoRequerimiento)
                        : undefined,
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha registrado una cotización");

                    if (this.props.formatoRequerimientoCotizaciones && hayDatosFormatoRequerimiento(values)) {
                        this.descargarFormatoRequerimientoGuardado(values, res.data.respuestaFactura?.dataSat);
                    }

                    if (window.registrarMovimiento) {
                        const dataSat = res.data.respuestaFactura.dataSat;
                        const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'C') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Rfc + ' - ' + dataSat.Receptor.Nombre + ' )';

                        window.registrarMovimiento({
                            titulo: 'Cotización Emitida',
                            mensaje: `${nombreArchivo} - Haga click para descargar`,
                            icono: 2,
                            onClick: () => {
                                const pdf = cotizacionPdf(res.data);
                                pdfMake.createPdf(pdf).download(nombreArchivo + ".pdf");
                            },
                        });
                    }

                    this.setState({
                        modalCorreo: true,
                        modalCorreoId: res.data.cotizacionId,
                    });
                } else if (res.data.success === 1) {
                    MensajeError({
                        message: res.data.message,
                        description: res.data.description,
                    });
                } else {
                    message.error("Hubo un error y la cotización no se registro");
                }
            });
    }
    // Al guardar se regresa el Formato Unico de Requerimiento lleno, ya con folio,
    // precio de lista, descuento y total. Queda tambien en movimientos para volver a
    // bajarlo en la sesion.
    descargarFormatoRequerimientoGuardado(values, dataSat) {
        try {
            const datos = datosFormatoDesdeCotizacion({ values, dataSat });
            const nombreArchivo = `Formato requerimiento ${datos.folio}.xlsx`;
            descargarFormatoRequerimiento(datos, nombreArchivo);
            if (window.registrarMovimiento) {
                window.registrarMovimiento({
                    titulo: "Formato de Requerimiento",
                    mensaje: `${datos.folio} - Haga click para descargar`,
                    icono: 2,
                    onClick: () => descargarFormatoRequerimiento(datos, nombreArchivo),
                });
            }
        } catch (error) {
            console.error("Error al generar el Formato Unico de Requerimiento:", error);
            message.error("La cotización se guardó, pero no se pudo generar el formato de requerimiento");
        }
    }
    atras() {
        this.props.history.goBack();
    }
    recalcularInsumosEnBatch = (insumosFormat) => {
        const clienteId = this.formRef.current.getFieldValue("clienteId");
        const tipoDeCambio = this.formRef.current.getFieldValue("tipoDeCambio");
        const noTax = this.state.quitarImpuestos;
        const arrayValue = [...insumosFormat];

        arrayValue.forEach((item, key) => {
            if (this.props.escuela) normalizarDescuentoFila(item);
            const insumoId = item.insumoId?._id || item.insumoId;
            const insumo = this.state.todasInsumos.find(
                (v) => v._id.toString() === insumoId?.toString()
            );
            if (!insumo) return;

            const precioUnitario = Number(item.precioUnitario);

            let totalImpuestosPrecioSinImpuestos = 0;
            if (!noTax) {
                insumo.impuestos.forEach((valueImpuesto) => {
                    let totalImpuesto;
                    if (valueImpuesto.tasaCuota === 1) {
                        totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
                    } else if (valueImpuesto.tasaCuota === 2) {
                        totalImpuesto = (precioUnitario + totalImpuestosPrecioSinImpuestos) * (valueImpuesto.monto / 100);
                    } else if (valueImpuesto.tasaCuota === 3) {
                        totalImpuesto = valueImpuesto.monto / tipoDeCambio;
                    } else {
                        totalImpuesto = 0;
                    }
                    totalImpuestosPrecioSinImpuestos += totalImpuesto;
                });
            }
            arrayValue[key].precioUnitarioConImpuestos = round2Decimals(precioUnitario + totalImpuestosPrecioSinImpuestos);

            const cantidad = item.cantidad;
            const descuento = item.descuento || 0;
            const descuentoCantidad = item.descuentoCantidad || 0;

            if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
                const subtotal = round6Decimals(cantidad * precioUnitario);
                const totalDescuento = round6Decimals(((subtotal * (descuento / 100)) || 0) + descuentoCantidad);
                const totalEntrada = round6Decimals(subtotal - totalDescuento);
                arrayValue[key].subtotal = totalEntrada;

                let totalImpuestos = 0;
                let arrayImpuestos = [];
                if (!noTax) {
                    arrayImpuestos = insumo.impuestos.map((valueImpuesto) => {
                        let totalImpuesto;
                        let baseImpuesto;
                        let montoImpuesto;
                        if (valueImpuesto.tasaCuota === 1) {
                            totalImpuesto = round6Decimals(totalEntrada * (valueImpuesto.monto / 100));
                            baseImpuesto = totalEntrada;
                            montoImpuesto = round6Decimals(valueImpuesto.monto / 100);
                        } else if (valueImpuesto.tasaCuota === 2) {
                            totalImpuesto = round6Decimals((totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100));
                            baseImpuesto = totalEntrada + totalImpuestos;
                            montoImpuesto = round6Decimals(valueImpuesto.monto / 100);
                        } else if (valueImpuesto.tasaCuota === 3) {
                            totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                            baseImpuesto = cantidad;
                            montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio);
                        } else if (valueImpuesto.tasaCuota === 5) {
                            totalImpuesto = 0;
                            baseImpuesto = totalEntrada;
                            montoImpuesto = 0;
                        }
                        totalImpuestos += totalImpuesto;
                        return {
                            tasaCuota: valueImpuesto.tasaCuota,
                            impuesto: valueImpuesto.impuesto,
                            montoImpuesto: montoImpuesto,
                            local: valueImpuesto.local,
                            baseImpuesto: baseImpuesto,
                            descripcionFactura: valueImpuesto.descripcionFactura,
                            totalImpuestos: totalImpuesto,
                        };
                    });
                }
                arrayValue[key].impuestos = totalImpuestos;
                arrayValue[key].arrayImpuestos = arrayImpuestos;
                arrayValue[key].total = round2Decimals(totalEntrada + totalImpuestos);

                if (!noTax && clienteId) {
                    const cliente = this.state.todasClientes.find(
                        (valueP) => valueP._id === clienteId
                    );
                    if (cliente) {
                        let totalRetenciones = 0;
                        const arrayRetenciones = [];
                        cliente.retenciones.forEach((valueRetencion) => {
                            let totalRetencion;
                            let baseRetencion;
                            if (valueRetencion.tasaCuota === 1) {
                                totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                                baseRetencion = totalEntrada;
                            } else if (valueRetencion.tasaCuota === 2) {
                                totalRetencion = round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                                baseRetencion = totalEntrada + totalImpuestos;
                            }
                            totalRetenciones += totalRetencion;
                            arrayRetenciones.push({
                                tasaCuota: valueRetencion.tasaCuota,
                                impuesto: valueRetencion.impuesto,
                                montoRetencion: valueRetencion.monto,
                                local: valueRetencion.local,
                                baseRetencion: baseRetencion,
                                descripcionFactura: valueRetencion.descripcionFactura,
                                totalRetenciones: totalRetencion,
                            });
                        });
                        insumo.retenciones.forEach((valueRetencion) => {
                            if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
                                let totalRetencion;
                                let baseRetencion;
                                if (valueRetencion.tasaCuota === 1) {
                                    totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                                    baseRetencion = totalEntrada;
                                } else if (valueRetencion.tasaCuota === 2) {
                                    totalRetencion = round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                                    baseRetencion = totalEntrada + totalImpuestos;
                                }
                                totalRetenciones += totalRetencion;
                                arrayRetenciones.push({
                                    tasaCuota: valueRetencion.tasaCuota,
                                    impuesto: valueRetencion.impuesto,
                                    montoRetencion: valueRetencion.monto,
                                    local: valueRetencion.local,
                                    baseRetencion: baseRetencion,
                                    descripcionFactura: valueRetencion.descripcionFactura,
                                    totalRetenciones: totalRetencion,
                                });
                            }
                        });
                        arrayValue[key].retenciones = totalRetenciones;
                        arrayValue[key].arrayRetenciones = arrayRetenciones;
                    }
                } else if (noTax) {
                    arrayValue[key].retenciones = 0;
                    arrayValue[key].arrayRetenciones = [];
                }
            }
        });

        this.formRef.current.setFieldsValue({ insumos: arrayValue });
    }

    // Carga masiva desde Excel: arma todos los renglones y los aplica con un solo
    // setFieldsValue (via recalcularInsumosEnBatch) en vez de un add() por renglon.
    cargarInsumosDesdeExcel = async (filasValidas, modo) => {
        const proyectoId = this.formRef.current.getFieldValue("proyectoId");
        const precioId = this.formRef.current.getFieldValue("precioId");
        const usarPrecioCliente = this.formRef.current.getFieldValue("usarPrecioCliente") !== false;

        const insumosNuevos = insumosNuevosParaCatalogo(filasValidas, this.state.todasInsumos);
        if (insumosNuevos.length > 0) {
            await new Promise((resolve) =>
                this.setState((prev) => ({ todasInsumos: [...prev.todasInsumos, ...insumosNuevos] }), resolve)
            );
        }

        const filasNuevas = construirFilasInsumosDesdeExcel({
            filas: filasValidas,
            proyectoId,
            precioId,
            usarPrecioCliente,
        });

        try {
            const resInventarios = await axios.post(
                "inventarios/inventarioInsumoProyectoBulk",
                {
                    empresaId: this.props.empresaId,
                    proyectoId,
                    insumos: payloadInventarioBulk(filasValidas, proyectoId),
                },
                { headers: this.props.headersToken }
            );
            aplicarInventarioBulk(filasNuevas, resInventarios.data?.results);
        } catch (error) {
            console.error("Error al consultar inventario en batch:", error);
        }

        const insumosActuales = this.formRef.current.getFieldValue("insumos") || [];
        const filasFinales = combinarFilasInsumos(insumosActuales, filasNuevas, modo);

        this.recalcularInsumosEnBatch(filasFinales);
        this.setState({ modalCargarExcelVisible: false });
        message.success(`${filasNuevas.length} línea(s) cargada(s) desde Excel.`);
    };

    // Formato Unico de Requerimiento (complemento formatoRequerimientoCotizaciones).
    // Mismos pasos que cargarInsumosDesdeExcel, mas el destino de cada renglon y los
    // datos del formato (contacto, fechas, direcciones) en la pestaña Requerimiento.
    cargarFormatoRequerimiento = async ({ encabezado, destinos, filas, modo }) => {
        const proyectoId = this.formRef.current.getFieldValue("proyectoId");
        const precioId = this.formRef.current.getFieldValue("precioId");
        const usarPrecioCliente = this.formRef.current.getFieldValue("usarPrecioCliente") !== false;

        const insumosNuevos = insumosNuevosParaCatalogo(filas, this.state.todasInsumos);
        if (insumosNuevos.length > 0) {
            await new Promise((resolve) =>
                this.setState((prev) => ({ todasInsumos: [...prev.todasInsumos, ...insumosNuevos] }), resolve)
            );
        }

        const filasNuevas = construirFilasInsumosDesdeExcel({
            filas,
            proyectoId,
            precioId,
            usarPrecioCliente,
        });
        filasNuevas.forEach((fila, index) => {
            const { destino, edicion } = filas[index];
            if (destino !== null && destino !== undefined) fila.destinoRequerimiento = destino;
            if (edicion) fila.edicionRequerimiento = edicion;
        });

        try {
            const resInventarios = await axios.post(
                "inventarios/inventarioInsumoProyectoBulk",
                {
                    empresaId: this.props.empresaId,
                    proyectoId,
                    insumos: payloadInventarioBulk(filas, proyectoId),
                },
                { headers: this.props.headersToken }
            );
            aplicarInventarioBulk(filasNuevas, resInventarios.data?.results);
        } catch (error) {
            console.error("Error al consultar inventario en batch:", error);
        }

        const insumosActuales = this.formRef.current.getFieldValue("insumos") || [];
        const filasFinales = combinarFilasInsumos(insumosActuales, filasNuevas, modo);
        this.recalcularInsumosEnBatch(filasFinales);

        const fechaMoment = (texto) => (texto ? moment(texto, "YYYY-MM-DD") : undefined);
        const datosFormato = {
            formatoRequerimiento: {
                clienteInstitucion: encabezado.clienteInstitucion || undefined,
                canal: encabezado.canal || undefined,
                contacto: encabezado.contacto || undefined,
                telefono: encabezado.telefono || undefined,
                correo: encabezado.correo || undefined,
                fechaRequerimiento: fechaMoment(encabezado.fechaRequerimiento),
                fechaEntregaRequerida: fechaMoment(encabezado.fechaEntregaRequerida),
                destinos: (destinos || []).map((d) => ({ ...d, numero: d.numero === null ? undefined : d.numero })),
            },
        };
        // Solo si estan vacios, para que salgan en el PDF de la cotizacion.
        if (encabezado.contacto && !this.formRef.current.getFieldValue("atencion")) {
            datosFormato.atencion = encabezado.contacto;
        }
        if (encabezado.fechaEntregaRequerida && !this.formRef.current.getFieldValue("fechaEntregaEstimada")) {
            datosFormato.fechaEntregaEstimada = fechaMoment(encabezado.fechaEntregaRequerida);
        }
        this.formRef.current.setFieldsValue(datosFormato);

        this.setState({ modalFormatoRequerimientoVisible: false });
        message.success(`${filasNuevas.length} línea(s) cargada(s) del formato. Revisa la pestaña Requerimiento.`);
    };

    onChangeInsumoProyecto = async (value, key, tipo, noPonerPrecio, insumoEncontrado) =>{
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let precioId = await this.formRef.current.getFieldValue("precioId");
        let clienteId = await this.formRef.current.getFieldValue("clienteId");
        let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        const noTax = this.state.quitarImpuestos;
        let proyectoId = arrayValue[key].proyectoId;
        const insumoId = arrayValue[key].insumoId;
        let insumo
        if (insumoEncontrado) {
            insumo = insumoEncontrado;
            await this.setState(prev => {
                const indiceExistente = prev.todasInsumos.findIndex(i => i._id === insumo._id);
                if (indiceExistente === -1) {
                    return { todasInsumos: [...prev.todasInsumos, insumo] };
                }
                const todasInsumosActualizado = [...prev.todasInsumos];
                todasInsumosActualizado[indiceExistente] = insumo;
                return { todasInsumos: todasInsumosActualizado };
            });
        } else {
            insumo = this.state.todasInsumos.find(
                (valueInsumos) => valueInsumos._id === insumoId
            );
        }
        // if(tipo === 'insumo'){
        //   function getAllIndexes(arr, val) {
        //     var indexes = [], i = -1;
        //     while ((i = arr.indexOf(val, i+1)) != -1){
        //         indexes.push(i);
        //     }
        //     return indexes;
        // }
        // }
        arrayValue[key].modoImagen = null;
        arrayValue[key].imprimirImagen = insumo.imprimirImagen;
        // Otro producto en el renglon: la descripcion larga vuelve al default de su catalogo.
        // Solo al cambiar de insumo; cambiar el proyecto no toca la eleccion.
        if (tipo === "insumo") arrayValue[key].imprimirDescripcionLarga = undefined;
        arrayValue[key].archivosPrincipal = [
        ...(insumo.archivosPrincipal || [])
        ];

        if (!arrayValue[key].archivosCargados) {
            arrayValue[key].archivosCargados = [];
        }

        if (!insumo) return;
        if (insumo.inventariable || insumo.insumoCompuesto) {
            await axios
                .post(
                    "inventarios/inventarioInsumoProyecto",
                    {
                        proyectoId: proyectoId,
                        insumoId: insumoId,
                        noPrincipal: insumo.noPrincipal,
                        insumoCompuesto: insumo.insumoCompuesto,
                        empresaId: this.props.empresaId,
                    },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    this.setState({ loading: false });
                    arrayValue[key].cantidadProyecto = res.data.cantidad;
                });
        } else {
            arrayValue[key].cantidadProyecto = "No inventariable";
        }

        if (tipo === "insumo") {
            const usarPrecioCliente = this.formRef.current.getFieldValue("usarPrecioCliente") !== false;
            const precio = insumo.precios.find(
                (valuePrecios) => valuePrecios.precioId?.toString() === precioId
            );
            if (!noPonerPrecio) {
                if (precio) {
                    arrayValue[key].precioUnitario = precio.precio;
                } else {
                    message.info("Este insumo no tiene ese precio");
                    arrayValue[key].precioUnitario = 0;
                }
                // Si el cliente tiene un precio unitario personalizado para este insumo, se prellena ese en vez del de la lista de precios
                if (usarPrecioCliente && insumo.precioClienteAlternativo !== undefined && insumo.precioClienteAlternativo !== null) {
                    arrayValue[key].precioUnitario = insumo.precioClienteAlternativo;
                }
            }
        }

        // Complemento Escuela: el insumo elegido trae el descuento predeterminado del
        // cliente como base. Sin poner precio (o al cambiar proyecto) se respeta el que traia.
        if (this.props.escuela) {
            if (tipo === "insumo" && !noPonerPrecio) {
                aplicarDescuentoBaseAFila(arrayValue[key], this.descuentoPredeterminadoCliente());
            } else {
                normalizarDescuentoFila(arrayValue[key]);
            }
        }

        // Descuento minimo de la lista, ya acotado por el margen minimo. Va antes
        // de que se lea `descuento` mas abajo para que el subtotal salga bien en
        // esta misma pasada; solo toca renglones que estan en 0.
        this.reglas.aplicarDescuentoMinimoAFila(key, arrayValue[key]);

        const precioUnitario = Number(arrayValue[key].precioUnitario)

        let totalImpuestosPrecioSinImpuestos = 0;
        if (!noTax) {
            insumo.impuestos.map((valueImpuesto) => {
                let totalImpuesto;
                if (valueImpuesto.tasaCuota === 1) {
                    totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
                } else if (valueImpuesto.tasaCuota === 2) {
                    totalImpuesto =
                        (precioUnitario + totalImpuestosPrecioSinImpuestos) *
                        (valueImpuesto.monto / 100);
                } else if (valueImpuesto.tasaCuota === 3) {
                    totalImpuesto = (valueImpuesto.monto / tipoDeCambio);
                } else if (valueImpuesto.tasaCuota === 5) {
                    totalImpuesto = 0
                }
                totalImpuestosPrecioSinImpuestos += totalImpuesto;
                return null;
            });
        }
        arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
            precioUnitario + totalImpuestosPrecioSinImpuestos
        );

        const cantidad = arrayValue[key].cantidad;
        const descuento = arrayValue[key].descuento || 0;
        const descuentoCantidad = arrayValue[key].descuentoCantidad || 0;

        if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
            //1
            const subtotal = round6Decimals(cantidad * precioUnitario);
            //2
            const totalDescuento = round6Decimals(((subtotal * (descuento / 100)) || 0) + descuentoCantidad);
            //3
            const totalEntrada = round6Decimals(subtotal - totalDescuento);
            arrayValue[key].subtotal = totalEntrada;

            let totalImpuestos = 0;
            let arrayImpuestos = [];
            if (!noTax) arrayImpuestos = insumo.impuestos.map(
                //4
                (valueImpuesto) => {
                    let totalImpuesto;
                    let baseImpuesto;
                    let montoImpuesto;
                    if (valueImpuesto.tasaCuota === 1) {
                        totalImpuesto = round6Decimals(
                            totalEntrada * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = totalEntrada
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 2) {
                        totalImpuesto = round6Decimals(
                            (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = (totalEntrada + totalImpuestos)
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 3) {
                        totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                        baseImpuesto = cantidad
                        montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
                    } else if (valueImpuesto.tasaCuota === 5) {
                        totalImpuesto = 0
                        baseImpuesto = totalEntrada
                        montoImpuesto = 0
                    }
                    totalImpuestos += totalImpuesto;
                    return {
                        tasaCuota: valueImpuesto.tasaCuota,
                        impuesto: valueImpuesto.impuesto,
                        montoImpuesto: montoImpuesto,
                        local: valueImpuesto.local,
                        baseImpuesto: baseImpuesto,
                        descripcionFactura: valueImpuesto.descripcionFactura,
                        totalImpuestos: totalImpuesto,
                    };
                }
            );
            arrayValue[key].impuestos = totalImpuestos;
            arrayValue[key].arrayImpuestos = arrayImpuestos;
            //5
            arrayValue[key].total = round2Decimals(
                arrayValue[key].subtotal + totalImpuestos
            );

            if (!noTax && clienteId) {
                //Consultar cliente

                const cliente = this.state.todasClientes.find(
                    (valueP) => valueP._id === clienteId
                );
                //6
                let totalRetenciones = 0;
                let arrayRetenciones = []
                cliente.retenciones.map((valueRetencion) => {
                    //7
                    let totalRetencion;
                    let baseRetencion;
                    if (valueRetencion.tasaCuota === 1) {
                        totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                        baseRetencion = totalEntrada
                    } else if (valueRetencion.tasaCuota === 2) {
                        totalRetencion =
                            round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                        baseRetencion = (totalEntrada + totalImpuestos)
                    }
                    totalRetenciones += totalRetencion;
                    arrayRetenciones.push({
                        tasaCuota: valueRetencion.tasaCuota,
                        impuesto: valueRetencion.impuesto,
                        montoRetencion: valueRetencion.monto,
                        local: valueRetencion.local,
                        baseRetencion: baseRetencion,
                        descripcionFactura: valueRetencion.descripcionFactura,
                        totalRetenciones: totalRetencion,
                    });
                    return null
                })

                insumo.retenciones.map((valueRetencion) => {
                    if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
                        //7
                        let totalRetencion;
                        let baseRetencion;
                        if (valueRetencion.tasaCuota === 1) {
                            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                            baseRetencion = totalEntrada
                        } else if (valueRetencion.tasaCuota === 2) {
                            totalRetencion =
                                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                            baseRetencion = (totalEntrada + totalImpuestos)
                        }
                        totalRetenciones += totalRetencion;
                        arrayRetenciones.push({
                            tasaCuota: valueRetencion.tasaCuota,
                            impuesto: valueRetencion.impuesto,
                            montoRetencion: valueRetencion.monto,
                            local: valueRetencion.local,
                            baseRetencion: baseRetencion,
                            descripcionFactura: valueRetencion.descripcionFactura,
                            totalRetenciones: totalRetencion,
                        });
                    }
                    return null
                })
                arrayValue[key].retenciones = totalRetenciones;
                arrayValue[key].arrayRetenciones = arrayRetenciones;
            } else if (noTax) {
                arrayValue[key].retenciones = 0;
                arrayValue[key].arrayRetenciones = [];
            }

        }
        this.formRef.current.setFieldsValue({
            insumos: arrayValue,
        });
        this.reglas.actualizarFila(key);
    }
    onChangePrecioConImpuestos = async (value, key) => {
        if (value === undefined || value === null || value === "") return;
    
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        let clienteId = await this.formRef.current.getFieldValue("clienteId");
        const noTax = this.state.quitarImpuestos;

        const insumo = this.state.todasInsumos.find(
          (valueInsumos) => valueInsumos._id === arrayValue[key].insumoId
        );
        if (!insumo) return;

        // Inversa correcta del precio con impuestos
        // Con impuestos quitados no hay nada que revertir: el precio neto capturado ES el precio unitario
        let factor = 1;
        let sumaCuotasFijas = 0;

        if (!noTax) {
          insumo.impuestos.forEach((valueImpuesto) => {
            const porcentaje = valueImpuesto.monto / 100;

            if (valueImpuesto.tasaCuota === 1) {
              // porcentaje sobre base
              factor += porcentaje;
            } else if (valueImpuesto.tasaCuota === 2) {
              // porcentaje sobre base + impuestos acumulados
              factor *= (1 + porcentaje);
            } else if (valueImpuesto.tasaCuota === 3) {
              // cuota fija
              sumaCuotasFijas += valueImpuesto.monto / tipoDeCambio;
            }
          });
        }

        const precioUnitario = round6Decimals(
          (Number(value) - sumaCuotasFijas) / factor
        );
    
        arrayValue[key].precioUnitario = precioUnitario;
    
        const cantidad = Number(arrayValue[key].cantidad || 0);
        const descuento = Number(arrayValue[key].descuento || 0);
        const descuentoCantidad = Number(arrayValue[key].descuentoCantidad || 0);
    
        if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
          const subtotal = round6Decimals(cantidad * precioUnitario);
          const totalDescuento = round6Decimals(
            ((subtotal * (descuento / 100)) || 0) + descuentoCantidad
          );
          const totalEntrada = round6Decimals(subtotal - totalDescuento);
          arrayValue[key].subtotal = totalEntrada;
    
          let totalImpuestos = 0;
          let arrayImpuestos = [];
          if (!noTax) arrayImpuestos = insumo.impuestos.map((valueImpuesto) => {
            let totalImpuesto = 0;
            let baseImpuesto = 0;
            let montoImpuesto = 0;
    
            if (valueImpuesto.tasaCuota === 1) {
              totalImpuesto = round6Decimals(
                totalEntrada * (valueImpuesto.monto / 100)
              );
              baseImpuesto = totalEntrada;
              montoImpuesto = round6Decimals(valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 2) {
              baseImpuesto = totalEntrada + totalImpuestos;
              totalImpuesto = round6Decimals(
                baseImpuesto * (valueImpuesto.monto / 100)
              );
              montoImpuesto = round6Decimals(valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 3) {
              totalImpuesto = round6Decimals(
                (cantidad * valueImpuesto.monto) / tipoDeCambio
              );
              baseImpuesto = cantidad;
              montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio);
            } else if (valueImpuesto.tasaCuota === 5) {
              totalImpuesto = 0;
              baseImpuesto = totalEntrada;
              montoImpuesto = 0;
            }
    
            totalImpuestos += totalImpuesto;
    
            return {
              tasaCuota: valueImpuesto.tasaCuota,
              impuesto: valueImpuesto.impuesto,
              montoImpuesto,
              local: valueImpuesto.local,
              baseImpuesto,
              descripcionFactura: valueImpuesto.descripcionFactura,
              totalImpuestos: totalImpuesto,
            };
          });
    
          arrayValue[key].impuestos = totalImpuestos;
          arrayValue[key].arrayImpuestos = arrayImpuestos;
          arrayValue[key].total = round2Decimals(
            arrayValue[key].subtotal + totalImpuestos
          );
    
          if (!noTax && clienteId) {
            const cliente = this.state.todasClientes.find(
              (valueP) => valueP._id === clienteId
            );

            if (cliente) {
              let totalRetenciones = 0;
              let arrayRetenciones = [];
    
              cliente.retenciones.forEach((valueRetencion) => {
                let totalRetencion = 0;
                let baseRetencion = 0;
    
                if (valueRetencion.tasaCuota === 1) {
                  totalRetencion = round6Decimals(
                    totalEntrada * (valueRetencion.monto / 100)
                  );
                  baseRetencion = totalEntrada;
                } else if (valueRetencion.tasaCuota === 2) {
                  baseRetencion = totalEntrada + totalRetenciones;
                  totalRetencion = round6Decimals(
                    baseRetencion * (valueRetencion.monto / 100)
                  );
                }
    
                totalRetenciones += totalRetencion;
    
                arrayRetenciones.push({
                  tasaCuota: valueRetencion.tasaCuota,
                  impuesto: valueRetencion.impuesto,
                  montoRetencion: valueRetencion.monto,
                  local: valueRetencion.local,
                  baseRetencion,
                  descripcionFactura: valueRetencion.descripcionFactura,
                  totalRetenciones: totalRetencion,
                });
              });
    
              insumo.retenciones.forEach((valueRetencion) => {
                if (
                  (valueRetencion.aplicaVenta === 1 && cliente.persona === false) ||
                  (valueRetencion.aplicaVenta === 2 && cliente.persona === true) ||
                  valueRetencion.aplicaVenta === 3
                ) {
                  let totalRetencion = 0;
                  let baseRetencion = 0;
    
                  if (valueRetencion.tasaCuota === 1) {
                    totalRetencion = round6Decimals(
                      totalEntrada * (valueRetencion.monto / 100)
                    );
                    baseRetencion = totalEntrada;
                  } else if (valueRetencion.tasaCuota === 2) {
                    baseRetencion = totalEntrada + totalRetenciones;
                    totalRetencion = round6Decimals(
                      baseRetencion * (valueRetencion.monto / 100)
                    );
                  }
    
                  totalRetenciones += totalRetencion;
    
                  arrayRetenciones.push({
                    tasaCuota: valueRetencion.tasaCuota,
                    impuesto: valueRetencion.impuesto,
                    montoRetencion: valueRetencion.monto,
                    local: valueRetencion.local,
                    baseRetencion,
                    descripcionFactura: valueRetencion.descripcionFactura,
                    totalRetenciones: totalRetencion,
                  });
                }
              });
    
              arrayValue[key].retenciones = totalRetenciones;
              arrayValue[key].arrayRetenciones = arrayRetenciones;
            }
          } else if (noTax) {
            arrayValue[key].retenciones = 0;
            arrayValue[key].arrayRetenciones = [];
          }
        }

        // conservar lo capturado por el usuario
        arrayValue[key].precioUnitarioConImpuestos = round2Decimals(Number(value));
    
        this.formRef.current.setFieldsValue({
          insumos: arrayValue,
        });
        this.reglas.actualizarFila(key);
      }
        onDobleClickDescuento = (arrayKey) => {
            this.setState(prev => ({
            tiposDescuento: {
                ...prev.tiposDescuento,
                [arrayKey]: prev.tiposDescuento[arrayKey] === 'cantidad' ? 'porcentaje' : 'cantidad'
            }
            }), () => {
            const insumos = this.formRef.current.getFieldValue('insumos')
            if (this.state.tiposDescuento[arrayKey] === 'cantidad') {
                if (this.props.escuela) {
                    // El Desc. Cliente se queda; solo se limpia el adicional en %.
                    insumos[arrayKey].descuentoAdicional = 0
                    sincronizarDescuentoFila(insumos[arrayKey])
                } else {
                    insumos[arrayKey].descuento = 0
                }
            } else {
                insumos[arrayKey].descuentoCantidad = 0
            }
            this.formRef.current.setFieldsValue({ insumos })
            this.onChangePrecioCantidadDescuento(0, arrayKey)
            })
        }

    // Complemento Escuela: % predeterminado del cliente seleccionado.
    descuentoPredeterminadoCliente = () => {
        const clienteId = this.formRef.current?.getFieldValue("clienteId");
        if (!clienteId) return 0;
        const cliente = (this.state.todasClientes || []).find(
            (valueCliente) => valueCliente._id?.toString() === clienteId.toString()
        );
        return cliente?.descuentoPredeterminado || 0;
    }

    // Complemento Escuela: Desc. Cliente y Desc. Adic. alimentan `descuento` (su
    // cascada), que es el unico que entra en el calculo.
    onChangeDescuentoEscuela = (arrayKey) => {
        const insumos = this.formRef.current.getFieldValue("insumos");
        sincronizarDescuentoFila(insumos[arrayKey]);
        this.formRef.current.setFieldsValue({ insumos });
        this.onChangePrecioCantidadDescuento(undefined, arrayKey);
    }
     onChangePrecioCantidadDescuento = async (value, key) => {
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let clienteId = await this.formRef.current.getFieldValue("clienteId");
        let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        const noTax = this.state.quitarImpuestos;
        const insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === arrayValue[key].insumoId
        );
        if (!insumo) return;
        const precioUnitario = Number(arrayValue[key].precioUnitario)

        let totalImpuestosPrecioSinImpuestos = 0;
        if (!noTax) {
            insumo.impuestos.map((valueImpuesto) => {
                let totalImpuesto;
                if (valueImpuesto.tasaCuota === 1) {
                    totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
                } else if (valueImpuesto.tasaCuota === 2) {
                    totalImpuesto =
                        (precioUnitario + totalImpuestosPrecioSinImpuestos) *
                        (valueImpuesto.monto / 100);
                } else if (valueImpuesto.tasaCuota === 3) {
                    totalImpuesto = (valueImpuesto.monto / tipoDeCambio);
                } else if (valueImpuesto.tasaCuota === 5) {
                    totalImpuesto = 0
                }
                totalImpuestosPrecioSinImpuestos += totalImpuesto;
                return null;
            });
        }
        arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
            precioUnitario + totalImpuestosPrecioSinImpuestos
        );
        const cantidad = arrayValue[key].cantidad;
        const descuento = arrayValue[key].descuento || 0;
        const descuentoCantidad = arrayValue[key].descuentoCantidad || 0;

        if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
            //1
            const subtotal = round6Decimals(cantidad * precioUnitario);
            //2
            const totalDescuento = round6Decimals(((subtotal * (descuento / 100)) || 0) + descuentoCantidad);
            //3
            const totalEntrada = round6Decimals(subtotal - totalDescuento);
            arrayValue[key].subtotal = totalEntrada;

            let totalImpuestos = 0;
            let arrayImpuestos = [];
            if (!noTax) {
                arrayImpuestos = insumo.impuestos.map(
                    //4
                    (valueImpuesto) => {
                        let totalImpuesto;
                        let baseImpuesto;
                        let montoImpuesto;
                        if (valueImpuesto.tasaCuota === 1) {
                            totalImpuesto = round6Decimals(
                                totalEntrada * (valueImpuesto.monto / 100)
                            );
                            baseImpuesto = totalEntrada
                            montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                        } else if (valueImpuesto.tasaCuota === 2) {
                            totalImpuesto = round6Decimals(
                                (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
                            );
                            baseImpuesto = (totalEntrada + totalImpuestos)
                            montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                        } else if (valueImpuesto.tasaCuota === 3) {
                            totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                            baseImpuesto = cantidad
                            montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
                        } else if (valueImpuesto.tasaCuota === 5) {
                            totalImpuesto = 0
                            baseImpuesto = totalEntrada
                            montoImpuesto = 0
                        }
                        totalImpuestos += totalImpuesto;
                        return {
                            tasaCuota: valueImpuesto.tasaCuota,
                            impuesto: valueImpuesto.impuesto,
                            montoImpuesto: montoImpuesto,
                            local: valueImpuesto.local,
                            baseImpuesto: baseImpuesto,
                            descripcionFactura: valueImpuesto.descripcionFactura,
                            totalImpuestos: totalImpuesto,
                        };
                    }
                );
            }
            arrayValue[key].impuestos = totalImpuestos;
            arrayValue[key].arrayImpuestos = arrayImpuestos;
            //5
            arrayValue[key].total = round2Decimals(
                arrayValue[key].subtotal + totalImpuestos
            );

            if (!noTax && clienteId) {
                //Consultar cliente

                const cliente = this.state.todasClientes.find(
                    (valueP) => valueP._id === clienteId
                );
                //6
                let totalRetenciones = 0;
                let arrayRetenciones = []
                cliente.retenciones.map((valueRetencion) => {
                    //7
                    let totalRetencion;
                    let baseRetencion;
                    if (valueRetencion.tasaCuota === 1) {
                        totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                        baseRetencion = totalEntrada
                    } else if (valueRetencion.tasaCuota === 2) {
                        totalRetencion =
                            round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                        baseRetencion = (totalEntrada + totalImpuestos)
                    }
                    totalRetenciones += totalRetencion;
                    arrayRetenciones.push({
                        tasaCuota: valueRetencion.tasaCuota,
                        impuesto: valueRetencion.impuesto,
                        montoRetencion: valueRetencion.monto,
                        local: valueRetencion.local,
                        baseRetencion: baseRetencion,
                        descripcionFactura: valueRetencion.descripcionFactura,
                        totalRetenciones: totalRetencion,
                    });
                    return null
                })
                insumo.retenciones.map((valueRetencion) => {
                    if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
                        //7
                        let totalRetencion;
                        let baseRetencion;
                        if (valueRetencion.tasaCuota === 1) {
                            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                            baseRetencion = totalEntrada
                        } else if (valueRetencion.tasaCuota === 2) {
                            totalRetencion =
                                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                            baseRetencion = (totalEntrada + totalImpuestos)
                        }
                        totalRetenciones += totalRetencion;
                        arrayRetenciones.push({
                            tasaCuota: valueRetencion.tasaCuota,
                            impuesto: valueRetencion.impuesto,
                            montoRetencion: valueRetencion.monto,
                            local: valueRetencion.local,
                            baseRetencion: baseRetencion,
                            descripcionFactura: valueRetencion.descripcionFactura,
                            totalRetenciones: totalRetencion,
                        });
                    }
                    return null
                })
                arrayValue[key].retenciones = totalRetenciones;
                arrayValue[key].arrayRetenciones = arrayRetenciones;
            } else if (noTax) {
                arrayValue[key].retenciones = 0;
                arrayValue[key].arrayRetenciones = [];
            }

        }
        this.formRef.current.setFieldsValue({
            insumos: arrayValue,
        });
        this.reglas.actualizarFila(key);
    }
    // Quita el nombre alterno cacheado de un cliente anterior para que no se le quede pegado a otro cliente
    limpiarAliasClienteInsumos() {
        this.setState((prev) => ({
            todasInsumos: prev.todasInsumos.map((insumo) => {
                if (!insumo.nombreClienteAlternativo) return insumo;
                const { nombreClienteAlternativo, ...resto } = insumo;
                return {
                    ...resto,
                    stringBuscar: `${insumo.clave || ''} - ${insumo.descripcion} - ${insumo.unidad || ''}`,
                };
            }),
        }));
    }

    async onChangeCliente(valueId, clienteEncontrado) {
        this.limpiarAliasClienteInsumos();
        let contado = this.formRef.current.getFieldValue("contado");
        this.setState({ loading: true });
        let cliente
        if (clienteEncontrado) {
            cliente = clienteEncontrado;
            const yaExiste = this.state.todasClientes.find(i => i._id === cliente._id);
            if (!yaExiste) {
                await this.setState(prev => ({
                    todasClientes: [...prev.todasClientes, cliente]
                }));
            }
        } else {
            cliente = this.state.todasClientes.find(
                (valueClientes) => valueClientes._id === valueId
            );
        }
        this.setState({ loading: false });
        if (!cliente.regimenFiscalId || !cliente.direcciones[0]?.coloniaId) {
            message.info('No se podra facturar a este cliente. Faltan datos')
        }
        if (!cliente.tipoClienteId) {
            const nombre = cliente.persona
                ? cliente.razonSocial
                : `${cliente.nombre} ${cliente.apellidoPaterno} ${cliente.apellidoMaterno}`;
            this.abrirElegirTipoDeCliente(cliente._id, nombre);
        }
        let objetoCambiar = {}
        if (cliente.usoDeCFDIID) {
            objetoCambiar.usoDeCfdiId = cliente.usoDeCFDIID
        }
        if (cliente.contado && this.state.ponerMetodoDePago) {
            objetoCambiar.contado = cliente.contado
            contado = cliente.contado
            this.onChangeContado(cliente.contado, true)
            message.info('Se actualizo el metodo de pago')
        }
        if (cliente.precioContadoId || cliente.precioCreditoId) {
            objetoCambiar.precioId = contado === 1 ? cliente.precioContadoId : cliente.precioCreditoId
        }
        if (cliente.proyectoId) {
            objetoCambiar.proyectoId = cliente.proyectoId
        }
        if (cliente.vendedorId && this.state.ponerVendedor && this.state.todasUsuarios?.find(u => u._id?.toString() === cliente.vendedorId?.toString())) {
            objetoCambiar.vendedorId = cliente.vendedorId
        }
        if (cliente.canalDeVentaId && this.state.ponerCanal && this.state.todasCanalesVenta?.find(c => c._id?.toString() === cliente.canalDeVentaId?.toString())) {
            objetoCambiar.canalDeVentaId = cliente.canalDeVentaId
        }
        if (cliente.monedaId){
            objetoCambiar.monedaId = cliente.monedaId
            this.onChangeMoneda(cliente.monedaId)
        }
        this.setState({
            complementoDetallista: cliente.complementoDetallista,
            leyenda: cliente.leyenda ? cliente.leyenda : null,
            detallista: {
                orderIdentification: cliente.orderIdentification,
                referenceDateOrderIdentification: cliente.referenceDateOrderIdentification,
                additionalInformation: cliente.additionalInformation,
                deliveryNote: cliente.deliveryNote,
                referenceDateDeliveryNote: cliente.referenceDateDeliveryNote,
            },
            direccionesCliente: cliente.direcciones,
            objetoDireccionesCliente: cliente.direcciones.map((value) => {
                return (
                    <Option value={value._id} key={value._id}>
                        {(value.calle || "Sin calle") + ' ' + (value.numeroCalle || "Sin número") + (value.numeroInterior ? ' Int. ' + value.numeroInterior : '') + ', ' + (value.colonia || "Sin colonia")}
                    </Option>
                )
            }),
        })
        this.formRef.current.setFieldsValue({
            diasCredito: cliente.diasCredito || 0,
            ...objetoCambiar
        });
        this.contadoAnterior = this.formRef.current.getFieldValue("contado");
        this.precioIdAnterior = this.formRef.current.getFieldValue("precioId");
        const insumos = this.formRef.current.getFieldValue("insumos");
        if (insumos?.length > 0) {
            // Complemento Escuela: el Desc. Cliente pasa a ser el del cliente nuevo y el
            // adicional se queda. Aqui solo entra el cambio de cliente del usuario.
            if (this.props.escuela) {
                insumos.forEach((fila) => {
                    if (fila?.insumoId) aplicarDescuentoBaseAFila(fila, cliente.descuentoPredeterminado);
                });
            }
            this.recalcularInsumosEnBatch(insumos);
        }
        if(cliente?.usarAdenda && cliente?.adendaActiva === "Mabe"){
            this.setState({ addendaMabe: true });
        }
        // Las reglas dependen del cliente y de su tipo de cliente.
        this.reglas.consultarContexto(valueId, this.formRef.current.getFieldValue("precioId"));

    }
    onChangePrecioId = (value) => {
        const insumos = this.formRef.current.getFieldValue("insumos");
        if (!insumos || insumos.length === 0) {
            this.precioIdAnterior = value;
            this.reglas.consultarContexto(undefined, value);
            return;
        }
        const anterior = this.precioIdAnterior;
        Modal.confirm({
            title: "Cambiar lista de precios",
            content: "Esta cotización ya tiene insumos agregados. Cambiar la lista de precios actualizará los precios e importes de todos los insumos ya agregados. ¿Deseas continuar?",
            okText: "Sí, actualizar precios",
            cancelText: "Cancelar",
            onOk: () => {
                this.precioIdAnterior = value;
                this.recalcularPreciosTodosLosInsumos(value);
                // Cada lista trae sus reglas y su descuento minimo.
                this.reglas.consultarContexto(undefined, value);
            },
            onCancel: () => {
                this.formRef.current.setFieldsValue({ precioId: anterior });
            },
        });
    };

    // Aplica la nueva lista de precios a todas las filas y delega el recálculo de
    // impuestos/retenciones/total en recalcularInsumosEnBatch (un solo setFieldsValue).
    recalcularPreciosTodosLosInsumos = (precioId) => {
        const insumos = this.formRef.current.getFieldValue("insumos");
        if (!insumos || insumos.length === 0) return;
        const usarPrecioCliente = this.formRef.current.getFieldValue("usarPrecioCliente") !== false;

        let sinPrecio = 0;
        const nuevosInsumos = insumos.map((fila) => {
            const insumoId = fila.insumoId?._id || fila.insumoId;
            const insumo = this.state.todasInsumos.find((i) => i._id.toString() === insumoId?.toString());
            if (!insumo) return fila;

            const precio = insumo.precios.find((p) => p.precioId?.toString() === precioId);
            if (!precio) sinPrecio++;
            let precioUnitario = precio ? precio.precio : 0;
            if (usarPrecioCliente && insumo.precioClienteAlternativo !== undefined && insumo.precioClienteAlternativo !== null) {
                precioUnitario = insumo.precioClienteAlternativo;
            }
            return { ...fila, precioUnitario };
        });

        this.recalcularInsumosEnBatch(nuevosInsumos);
        if (sinPrecio > 0) {
            message.info(`${sinPrecio} insumo(s) no tienen precio en esta lista y se dejaron en $0.`);
        }
    };
    refrescarInsumosCliente = async (usarPrecioCliente) => {
        try {
            const todasInsumos = await refrescarCatalogoInsumosCliente({
                empresaId: this.props.empresaId,
                clienteId: this.formRef.current.getFieldValue("clienteId"),
                usarPrecioCliente,
                insumos: this.formRef.current.getFieldValue("insumos"),
                todasInsumos: this.state.todasInsumos,
                headersToken: this.props.headersToken,
            });
            await new Promise((resolve) => this.setState({ todasInsumos }, resolve));
        } catch (error) {
            console.error("Error al refrescar los insumos del cliente:", error);
        }
    };
    onChangeUsarPrecioCliente = (checked) => {
        const insumos = this.formRef.current.getFieldValue("insumos");
        if (!insumos || insumos.length === 0) {
            this.usarPrecioClienteAnterior = checked;
            return;
        }
        const precioId = this.formRef.current.getFieldValue("precioId");
        const anterior = this.usarPrecioClienteAnterior;
        Modal.confirm({
            title: "Cambiar Usar Precio de Cliente",
            content: "Esta cotización ya tiene insumos agregados. Cambiar esta opción actualizará los precios e importes de todos los insumos ya agregados. ¿Deseas continuar?",
            okText: "Sí, actualizar precios",
            cancelText: "Cancelar",
            onOk: async () => {
                this.usarPrecioClienteAnterior = checked;
                await this.refrescarInsumosCliente(checked);
                this.recalcularPreciosTodosLosInsumos(precioId);
                // Cambiaron los precios, asi que hay que revisar los rangos de nuevo.
                this.reglas.revisarTodas();
            },
            onCancel: () => {
                this.formRef.current.setFieldsValue({ usarPrecioCliente: anterior });
            },
        });
    };
    onChangeContado(value, inicial, metodoClienteId = null) {
        const insumos = this.formRef.current.getFieldValue("insumos");
        const clienteId = this.formRef.current.getFieldValue("clienteId");
        const cliente = clienteId && this.state.todasClientes.find(
            (valueProv) => valueProv._id === clienteId
        );
        const nuevoPrecioId = cliente ? (value === 1 ? cliente.precioContadoId : cliente.precioCreditoId) : null;
        const precioIdActual = this.formRef.current.getFieldValue("precioId");
        const esCambioReal = !inicial || !!inicial?.children;

        if (esCambioReal && insumos?.length > 0 && clienteId && nuevoPrecioId && nuevoPrecioId !== precioIdActual) {
            const anterior = this.contadoAnterior;
            Modal.confirm({
                title: value === 1 ? "Cambiar a Contado" : "Cambiar a Crédito",
                content: "Esta cotización ya tiene insumos agregados. Cambiar el método actualizará la lista de precios y, con ella, los precios e importes de los insumos ya agregados. ¿Deseas continuar?",
                okText: "Sí, actualizar precios",
                cancelText: "Cancelar",
                onOk: () => {
                    this.contadoAnterior = value;
                    this.precioIdAnterior = nuevoPrecioId;
                    this.formRef.current.setFieldsValue({ precioId: nuevoPrecioId });
                    this.recalcularPreciosTodosLosInsumos(nuevoPrecioId);
                    // Cambio la lista, asi que cambian las reglas y el descuento minimo.
                    this.reglas.consultarContexto(clienteId, nuevoPrecioId);
                },
                onCancel: () => {
                    this.formRef.current.setFieldsValue({ contado: anterior });
                },
            });
            return;
        }

        if (insumos?.length > 0) { this.contadoAnterior = value; return; }
        if (!clienteId) { this.contadoAnterior = value; return; }
        if (esCambioReal) {
            this.formRef.current.setFieldsValue({
                precioId: nuevoPrecioId,
            });
            this.precioIdAnterior = nuevoPrecioId;
        }
        this.contadoAnterior = value;
    }
    abrirElegirTipoDeCliente(id, nombre) {
        this.setState({
            modalElegirTipoDeCliente: true,
            modalElegirTipoDeClienteId: id,
            modalElegirTipoDeClienteNombre: nombre,
        });
    }
    cerrarElegirTipoDeCliente(elegido) {
        if (!elegido) {
            this.formRef.current.setFieldsValue({ clienteId: undefined });
        }
        this.consultarTodo();
        this.setState({
            modalElegirTipoDeCliente: false,
            modalElegirTipoDeClienteId: null,
            modalElegirTipoDeClienteNombre: null,
        });
    }
    cerrarMandarCorreoCotizacion() {
        this.setState({
            modalCorreo: false,
            modalCorreoId: null,
        });
        this.formRef.current.resetFields();
        this.atras();
    }
    abrirLeyenda = (value, leyenda, insumoId) => {
        const insumo = this.state.todasInsumos.find(valueTI => valueTI._id.toString() === insumoId.toString())

        const clienteIdActual = this.formRef.current.getFieldValue('clienteId');
        const clienteActual = this.state.todasClientes.find(c => c._id === clienteIdActual);            const nombreClienteActual = clienteActual ? (clienteActual.persona ? clienteActual.razonSocial : `${clienteActual.nombre} ${clienteActual.apellidoPaterno} ${clienteActual.apellidoMaterno}`) : 'Cliente Desconocido';

        this.setState({
            modalLeyenda: true,
            modalLeyendaIndex: value,
            modalLeyendaLeyenda: leyenda,
            modalLeyendaLeyendasPasadas: insumo?.leyendasPasadas,
            clienteIdActual: clienteIdActual, 
            nombreClienteActual: nombreClienteActual
        })
    }
    cerrarLeyenda = (value) =>{
        const insumos = this.formRef.current.getFieldValue('insumos')
        insumos[this.state.modalLeyendaIndex].leyenda = value
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalLeyenda: false,
            modalLeyendaIndex: null,
            modalLeyendaLeyenda: null,
            modalLeyendaLeyendasPasadas: null,
            clienteIdActual: null,
            nombreClienteActual: null
        })
    }

    abrirObservaciones = (value, observaciones, insumoId, observacionesXml) =>{
        const insumo = this.state.todasInsumos.find(valueTI => valueTI._id.toString() === insumoId.toString())
        const clienteIdActual = this.formRef.current.getFieldValue('clienteId');
        const clienteActual = this.state.todasClientes.find(c => c._id === clienteIdActual);            const nombreClienteActual = clienteActual ? (clienteActual.persona ? clienteActual.razonSocial : `${clienteActual.nombre} ${clienteActual.apellidoPaterno} ${clienteActual.apellidoMaterno}`) : 'Cliente Desconocido';

        this.setState({
            modalObservaciones: true,
            modalObservacionesIndex: value,
            modalObservacionesObservaciones: observaciones,
            modalObservacionesObservacionesXml: observacionesXml,
            modalObservacionesObservacionesPasadas: insumo?.observacionesPasadas, 
            clienteIdActual: clienteIdActual, 
            nombreClienteActual: nombreClienteActual
        })
    }
    cerrarObservaciones(value, observacionesXml) {
        const insumos = this.formRef.current.getFieldValue('insumos')
        insumos[this.state.modalObservacionesIndex].observaciones = value
        insumos[this.state.modalObservacionesIndex].observacionesXml = observacionesXml
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalObservaciones: false,
            modalObservacionesIndex: null,
            modalObservacionesObservaciones: null,
            modalObservacionesObservacionesXml: null,
            modalObservacionesObservacionesPasadas: null,
            clienteIdActual: null,
            nombreClienteActual: null
        })
    }

    handleCheckboxChange = (e) => {
        this.setState({ leyendaActiva: e.target.checked });
    };

    abrirElegirLotes = (value, lotes, insumoId, proyectoId, cantidad) =>{
        const clienteId = this.formRef.current.getFieldValue('clienteId')
        if (proyectoId) {
            this.setState({
                modalElegirLotes: true,
                modalElegirLotesIndex: value,
                modalElegirLotesLotes: lotes || [],
                modalElegirLotesInsumoId: insumoId,
                modalElegirLotesProyectoId: proyectoId,
                modalElegirLotesClienteId: clienteId,
                modalElegirLotesCantidad: cantidad
            })
        } else {
            message.warning('Elegir un proyecto para elegir lotes')
        }
    }
    cerrarElegirLotes(value) {
        const insumos = this.formRef.current.getFieldValue('insumos')
        insumos[this.state.modalElegirLotesIndex].lotes = value
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalElegirLotes: false,
            modalElegirLotesIndex: null,
            modalElegirLotesLotes: null,
            modalElegirLotesInsumoId: null,
            modalElegirLotesProyectoId: null,
            modalElegirLotesClienteId: null,
            modalElegirLotesCantidad: null
        })
    }


    abrirElegirAgrupaciones = (value, agrupaciones, insumoId, proyectoId) =>{
        const clienteId = this.formRef.current.getFieldValue('clienteId')
        if (proyectoId) {
            this.setState({
                modalElegirAgrupaciones: true,
                modalElegirAgrupacionesIndex: value,
                modalElegirAgrupacionesAgrupaciones: agrupaciones || [],
                modalElegirAgrupacionesInsumoId: insumoId,
                modalElegirAgrupacionesProyectoId: proyectoId,
                modalElegirAgrupacionesClienteId: clienteId
            })
        } else {
            message.warning('Elegir un proyecto para elegir agrupaciones')
        }
    }
    cerrarElegirAgrupaciones(value) {
        const insumos = this.formRef.current.getFieldValue('insumos')
        if (insumos[this.state.modalElegirAgrupacionesIndex]?.agrupaciones) {
            insumos[this.state.modalElegirAgrupacionesIndex].agrupaciones = value
        }
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalElegirAgrupaciones: false,
            modalElegirAgrupacionesIndex: null,
            modalElegirAgrupacionesAgrupaciones: null,
            modalElegirAgrupacionesInsumoId: null,
            modalElegirAgrupacionesProyectoId: null,
            modalElegirAgrupacionesClienteId: null
        })
    }

    abrirVerInsumo = async (key) => {
        if (!this.props.permisoModificarPrecioUnitario) return;
        const arrayValue = await this.formRef.current.getFieldValue("insumos");
        const precioId = await this.formRef.current.getFieldValue("precioId");
        const tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        const insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === arrayValue[key].insumoId
        );
        if (!insumo) return;

        if (insumo.verInsumoVenta) {
            this.setState({
                modalVerInsumo: true,
                modalVerInsumoId: insumo._id,
                modalVerInsumoPrecioId: precioId,
                modalVerInsumoIndex: key,
                modalVerInsumoTipoDeCambio: tipoDeCambio
            })
        }
    }

    cerrarVerInsumo = async (precio) => {

        if (precio && precio > 0) {
            const insumos = await this.formRef.current.getFieldValue('insumos');
            insumos[this.state.modalVerInsumoIndex].precioUnitario = precio;
            await this.formRef.current.setFieldsValue({ insumos });
            this.onChangePrecioCantidadDescuento(undefined, this.state.modalVerInsumoIndex);
        }

        this.setState({
            modalVerInsumo: false,
            modalVerInsumoId: null,
            modalVerInsumoPrecioId: null,
            modalVerInsumoIndex: 0,
            modalVerInsumoTipoDeCambio: 1
        });
    }

    async onChangeEstado(value, inicial) {
        if (!inicial) {
            this.formRef.current.setFieldsValue({
                direccionEntrega: {
                    municipioId: undefined,
                    coloniaId: undefined
                }
            });
        }
        await axios
            .post(
                "municipios/selectMunicipios",
                { estadoId: value },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    let objetoMunicipios = res.data.map((value) => {
                        return (
                            <Option value={value._id} key={value._id}>
                                {value.nombre}
                            </Option>
                        );
                    });
                    this.setState({
                        todasMunicipios: res.data,
                        objetoMunicipios: objetoMunicipios,
                    });
                }
            });
    }

    async onChangeMunicipio(value, inicial) {
        await axios
            .post(
                "colonias/selectColonias",
                { municipioId: value },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    let objetoColonias = res.data.map((value) => {
                        return (
                            <Option value={value._id} key={value._id}>
                                {value.cp + " - " + value.nombre}
                            </Option>
                        );
                    });
                    this.setState({
                        todasColonias: res.data,
                        objetoColonias: objetoColonias,
                    });
                }
            });
    }


    async onSearchColonia(value) {
        if (value.toString().length === 5) {
            await axios
                .post(
                    "colonias/buscarCP",
                    { cp: value },
                    {
                        headers: this.props.headersToken,
                    }
                )
                .then((res) => {
                    if (res.data.status === 404) {
                        message.info("No se encontro el codigo postal");
                    } else {
                        this.formRef.current.setFieldsValue({
                            direccionEntrega: {
                                paisId: res.data.paisId,
                                estadoId: res.data.estadoId,
                                municipioId: res.data.municipioId
                            }
                        });
                        this.onChangeEstado(res.data.estadoId, true);
                        this.onChangeMunicipio(res.data.municipioId, true);
                    }
                });
        }
    }
    async onSelectColoniaId(coloniaId, fieldKey) {
        const direccionEntrega = this.formRef.current.getFieldValue("direccionEntrega");
        if (!direccionEntrega?.colonia) {
            const nombreColonia = this.state.todasColonias.find((todasColonia) => todasColonia._id.toString() === coloniaId.toString())?.nombre
            await this.formRef.current.setFieldsValue({
                direccionEntrega: {
                    colonia: nombreColonia
                }
            })
        }
    }

    async handleChangeDireccionEntrega(value) {
        this.setState({ loadingEntrega: true })
        if (value) {
            const direccion = this.state.direccionesCliente.find((direccion) => direccion._id.toString() === value.toString())
            if (direccion) {
                if (direccion.estadoId) {
                    await this.onChangeEstado(direccion.estadoId, true);
                }
                if (direccion.municipioId) {
                    await this.onChangeMunicipio(direccion.municipioId, true);
                }
                if (direccion.plantaEntregaId) {

                    this.onSearchPlantaEntrega(direccion.plantaEntregaId, "direccionEntrega", { byId: true, setSelected: false });
                }
                this.formRef.current.setFieldsValue({
                    direccionEntrega: {
                        paisId: direccion.paisId,
                        estadoId: direccion.estadoId,
                        municipioId: direccion.municipioId,
                        coloniaId: direccion.coloniaId,
                        colonia: direccion.colonia,
                        calle: direccion.calle,
                        numeroCalle: direccion.numeroCalle,
                        numeroInterior: direccion.numeroInterior,
                        descripcion: direccion.descripcion,
                        telefono: direccion.telefono,
                        correo: direccion.correo,
                        observaciones: direccion.observaciones,
                        plantaEntregaId: direccion.plantaEntregaId,
                        referencia: direccion.referencia,
                        clienteNombre: direccion?.clienteNombre,
                        clienteRfc: direccion?.clienteRfc
                    }
                })
            }
        }
        this.setState({ loadingEntrega: false })
    }

    consultarInformacionEntrega() {
        if (this.state.todasPaises.length > 0) return
        this.setState({ loadingEntrega: true })
        const direccionEntrega = this.formRef.current.getFieldValue("direccionEntrega");

        axios.post("direcciones/selectInformacionDomicilio", { direccion: direccionEntrega }, {
            headers: this.props.headersToken
        })
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        loadingEntrega: false,
                        todasPaises: res.data.paises,
                        todasEstado: res.data.estados,
                        todasMunicipios: res.data.municipios,
                        todasColonias: res.data.colonias,
                        objetoMunicipios: res.data.municipios.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoColonias: res.data.colonias.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.cp + " - " + value.nombre}
                                </Option>
                            );
                        }),
                        objetoPaises: res.data.paises.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviatura}
                                </Option>
                            );
                        }),
                        objetoEstados: res.data.estados.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviatura}
                                </Option>
                            );
                        }),
                    })
                } else {
                    message.info("No se encontró información para entrega")
                    this.setState({
                        loadingEntrega: false
                    })
                }
            })
    }

    onChangeMoneda(value) {
        if (value && value !== '60c7e4396465ad440c41c15a') {
            axios
                .post(
                    "tipoDeCambio/obtenerTipoDeCambio",
                    {
                        monedaId: value,
                        empresaId: this.props.empresaId,
                    },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    if (res.data.success === 2) {
                        if (res.data.monedaString && res.data.dia) {
                            message.success("Se ha obtenido el tipo de cambio" + (res.data.monedaString ? (" " + res.data.monedaString) : '') + (res.data.dia ? (' del día ' + res.data.dia) : ''));
                        }
                        this.formRef.current.setFieldsValue({
                            tipoDeCambio: res.data.tipoDeCambio,
                        });
                    }
                });
        }
    }
    onSearchPlantaEntrega = (value, fieldKey, opts = {}) => {
        const { byId = false, setSelected = false } = opts;
        if (byId) {
            axios
                .post(
                    "plantaDeEntrega/selectPlantaEntregaPorId",
                    { id: value },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    const p = res?.data?.dato || null;
                    if (!p || !p._id) {
                        this.setState(prev => ({
                            objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
                            loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                        }));
                        message.warning("No se encontró la planta por ID.");
                        return;
                    }

                    const option = (
                        <Option key={p._id} value={p._id} padre={p.plantaEntregaId}>
                            {p.label}
                        </Option>
                    );

                    this.setState(prev => ({
                        objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [option] },
                        loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                    }));

                    if (setSelected && (this.props.form?.setFieldsValue || this.form?.setFieldsValue)) {
                        const form = this.props.form || this.form;
                        form.setFields([
                            { name: ['"direccionEntrega"', fieldKey, 'plantaEntregaId'], value: p._id }
                        ]);
                    }
                })
                .catch((err) => {
                    console.error(err);
                    message.error("Error al buscar planta por ID");
                    this.setState(prev => ({
                        objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
                        loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                    }));
                });

            return;
        }
        this.setState(prev => ({
            loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: true }
        }));
        axios
            .post(
                "plantaDeEntrega/selectPlantasDeEntrega",
                {
                    query: value || ""
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res?.data.success !== 2) {
                    this.setState(prev => ({
                        objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
                        loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                    }));
                    return;
                }
                const items = Array.isArray(res.data.plantas) ? res.data.plantas : [];
                const options = items.map(it => (
                    <Option key={it._id} value={it._id} padre={it.plantaEntregaId}>
                        {it.label}
                    </Option>
                ));

                this.setState(prev => ({
                    objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: options },
                    loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                }));
            })
            .catch((err) => {
                console.error(err);
                message.error("Error al buscar plantas de entrega");
                this.setState(prev => ({
                    objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
                    loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                }));
            });
    }

    toggleOpcionesImagen = (index) => {
        this.setState(prev => ({
            opcionImagen: prev.opcionImagen === index ? null : index
        }));
    }

    seleccionarModoImagen = (index, modo) => {
        const insumos = this.formRef.current.getFieldValue('insumos');
        const valorActual = insumos[index].modoImagen;

        insumos[index].modoImagen = valorActual === modo ? null : modo;
        insumos[index].imprimirImagen = !!insumos[index].modoImagen;
        this.formRef.current.setFieldsValue({ insumos });
        this.setState({});
    }

    // Boton "Desc. larga" del renglon: guarda la eleccion explicita (true/false). Sin ella
    // manda el default del catalogo (insumo.descripcionLargaVenta).
    toggleDescripcionLarga = (index, valor) => {
        const insumos = this.formRef.current.getFieldValue('insumos');
        insumos[index] = { ...insumos[index], imprimirDescripcionLarga: valor };
        this.formRef.current.setFieldsValue({ insumos });
        this.setState({});
    }



    activarImagenesGlobal = () => {
        const insumos = this.formRef.current.getFieldValue('insumos');
        if (!insumos || insumos.length === 0) return;

        const insumosActualizados = insumos.map(insumo => {
        if (!insumo) return insumo;
        
        //Si el insumo tiene imagenes se activa su uso
        const tieneImagenes = insumo.archivosPrincipal && insumo.archivosPrincipal?.length > 0;
        
        if (tieneImagenes) {
             return { 
                 ...insumo, 
                 modoImagen: 'insumo',
                 imprimirImagen: true 
             };
        }
        return insumo;
    });

        this.formRef.current.setFieldsValue({ insumos: insumosActualizados });
        this.setState({});
        message.success("Imágenes de catálogo activadas");
    }

    limpiarImagenesGlobal = () => {
        const insumos = this.formRef.current.getFieldValue('insumos');
        if (!insumos || insumos.length === 0) return;

        const insumosActualizados = insumos.map(insumo => {
            if (!insumo) return insumo;
            return { ...insumo, modoImagen: null ,  imprimirImagen: false};
        });

        this.formRef.current.setFieldsValue({ insumos: insumosActualizados });
        this.setState({});
        message.info("Selección de imágenes limpiada");
    }

    abrirModalImagen = (index) => {
        this.setState({
            modalImagenVisible: true,
            indiceFilaImagen: index
        });
    }

    cerrarModalImagen = () => {
        this.setState({
            modalImagenVisible: false,
            indiceFilaImagen: null
        });
    }

    guardarImagenEnFormulario = (listaArchivos, guardarEnInsumo) => {
        const { indiceFilaImagen, todasInsumos } = this.state;
        const insumos = this.formRef.current.getFieldValue('insumos');

        if (insumos && insumos[indiceFilaImagen]) {

            insumos[indiceFilaImagen].archivosCargados = listaArchivos;

            if (listaArchivos && listaArchivos.length > 0) {
                // Si hay foto, se pone en verde
                insumos[indiceFilaImagen].modoImagen = 'cargar';
                insumos[indiceFilaImagen].imprimirImagen = true;

                if (guardarEnInsumo) {
                    const insumoId = insumos[indiceFilaImagen].insumoId;
                    const indexMaestro = todasInsumos.findIndex(i => i._id === insumoId);

                    if (indexMaestro !== -1) {
                        const copiaTodasInsumos = [...todasInsumos];
                        const insumoMaestro = { ...copiaTodasInsumos[indexMaestro] };

                        if (!insumoMaestro.archivosPrincipal) insumoMaestro.archivosPrincipal = [];

                        // Validación del limite antes de guardar
                        if (insumoMaestro.archivosPrincipal.length < 3) {

                            const nuevaImagen = listaArchivos[0].url || listaArchivos[0].thumbUrl || listaArchivos[0].preview;

                            insumoMaestro.archivosPrincipal.push(nuevaImagen);

                            copiaTodasInsumos[indexMaestro] = insumoMaestro;
                            this.setState({ todasInsumos: copiaTodasInsumos });

                            insumos[indiceFilaImagen].actualizarInsumo = true;

                            message.success("Imagen asignada temporalmente al catálogo.");
                        }
                    }
                }

            } else {
                insumos[indiceFilaImagen].modoImagen = null;
                insumos[indiceFilaImagen].actualizarInsumo = false;                
                insumos[indiceFilaImagen].imprimirImagen = false;

            }

            // Lógica existente de insumo de cambio...
            const insumoData = todasInsumos.find(i => i._id === insumos[indiceFilaImagen].insumoId);
            if (listaArchivos && listaArchivos.length > 0 && insumoData && insumoData.insumoCambio) {
                insumos[indiceFilaImagen].imprimirImagen = true;
                message.info("Se activó imprimir imagen por ser insumo de cambio.");
            }

            // Actualizamos el formulario
            this.formRef.current.setFieldsValue({ insumos });

            // Refrescamos render
            this.setState({});

            if (listaArchivos && listaArchivos.length > 0) {
                message.success("Imagen lista para la cotización");
            }
        }

        this.cerrarModalImagen();
    }


    abrirVistaPreviaInsumo = (index, e) => {
        if (e) e.preventDefault();

        const insumos = this.formRef.current.getFieldValue('insumos');
        const fila = insumos[index];

        if (fila && fila.archivosPrincipal && fila.archivosPrincipal.length > 0) {
            const archivo = fila.archivosPrincipal[0];
            let urlFinal = '';
            if (archivo.startsWith('http') || archivo.startsWith('https')) {
                urlFinal = archivo;
            }
            else {
                let normalizedPath = archivo.replace(/\\/g, '/');

                if (!normalizedPath.startsWith('/')) {
                    normalizedPath = '/' + normalizedPath;
                }
                urlFinal = normalizedPath;
            }
            this.setState({
                modalVistaPreviaVisible: true,
                vistaPreviaUrl: urlFinal,
            });
        } else {
            message.info("Este insumo no tiene imagen de catálogo disponible.");
        }
    }

    cerrarVistaPreviaInsumo = () => {
        this.setState({
            modalVistaPreviaVisible: false,
            vistaPreviaUrl: '',
        });
    }

    //Funcion para guardar un nuevo paquete
    agregarPaquete = () => {
        //Abre la columna para agregar paquetes al paquete 
        this.setState({ mostrarDatosPaquete: true }); 

    }

    //Funcion para guardar los indices seleccionados del paquete
    onCheckInsumoPaquete = (e,index) => {
        const {checked} = e.target;
        const {indicesSeleccionadosPaquete} = this.state;

        let nuevosIndices = [...indicesSeleccionadosPaquete];
        if (checked) {
            nuevosIndices.push(index);
        } else {
            nuevosIndices = nuevosIndices.filter(i => i !== index);
        }
        this.setState({ indicesSeleccionadosPaquete: nuevosIndices });
    }

    //Agregar un nuevo paquete
    guardarPaquete = () => {
        const {nombrePaquete, indicesSeleccionadosPaquete, paquetes, paqueteEditadoId} = this.state;
        const insumosForm = this.formRef.current.getFieldValue('insumos') || [];

        if(!nombrePaquete || nombrePaquete.trim() === '') {
            message.error('El nombre del paquete es obligatorio.');
            return;
        }
        if(indicesSeleccionadosPaquete.length === 0) {
            message.error('Debe seleccionar al menos un insumo para crear el paquete.');
            return;
        }

        const esEdicion = !!paqueteEditadoId; 
        const paqueteId = esEdicion? paqueteEditadoId : "PKG_" + Date.now();
        
        const paqueteActualMeta = esEdicion ? paquetes.find(p => p.idInterno === paqueteId) : {};
        const imprimirDesglose = esEdicion ? paqueteActualMeta.imprimirDesglose : true; // Default true

        let insumosDePaquetesAjenos = [];
        let insumosDeEstePaquete = [];
        let insumosSueltos = [];

        insumosForm.forEach((insumo, index) => {
            if (insumo._paqueteId && insumo._paqueteId !== paqueteId) {
                insumosDePaquetesAjenos.push(insumo);
                return;
            }

            // Si está seleccionado para ESTE paquete
            if (indicesSeleccionadosPaquete.includes(index)) {                
                insumosDeEstePaquete.push({
                    ...insumo,
                    _paqueteId: paqueteId,
                    _nombrePaquete: nombrePaquete,
                });
            } 
            else {
                if (esEdicion && insumo._paqueteId === paqueteId) {
                    insumosSueltos.push({
                        ...insumo,
                        _paqueteId: null,
                        _nombrePaquete: null,
                    });
                } else {
                    insumosSueltos.push(insumo);
                }
            }
        });

        const nuevoMetadata = {
            idInterno: paqueteId,
            nombre: nombrePaquete,
            cantidad: esEdicion ? (paqueteActualMeta.cantidad || 1) : 1,
            imprimirDesglose: imprimirDesglose
        };

        let nuevosPaquetesMeta;
        if (esEdicion) {
            nuevosPaquetesMeta = paquetes.map(p => p.idInterno === paqueteId ? nuevoMetadata : p);
        } else {
            nuevosPaquetesMeta = [...paquetes, nuevoMetadata];
        }

        const nuevosInsumosOrdenados = [...insumosDePaquetesAjenos, ...insumosDeEstePaquete, ...insumosSueltos];

        this.formRef.current.setFieldsValue({ insumos: nuevosInsumosOrdenados });
        this.setState({
            paquetes: nuevosPaquetesMeta,
            mostrarDatosPaquete: false,
            nombrePaquete: '',
            indicesSeleccionadosPaquete: [],
            paqueteEditadoId: null
        });

        message.success(esEdicion ? "Paquete actualizado" : "Paquete creado");
    }
      

    //Función para editar el paquete
    editarPaquete = (paqueteId) => {
        const {paquetes} = this.state; 
        const insumosForm = this.formRef.current.getFieldValue("insumos");
        const paqueteMeta = paquetes.find(p => p.idInterno === paqueteId);

        if(!paqueteMeta) return; // si no encontro el paquete 

        const indices = []; 
        insumosForm.forEach((item, index) => {
            if (item._paqueteId === paqueteId) {
                indices.push(index);
            }
        });

        this.setState({
            mostrarDatosPaquete: true,
            nombrePaquete: paqueteMeta.nombre,
            indicesSeleccionadosPaquete: indices,
            paqueteEditadoId: paqueteId 
        });
        
        message.info("Editando paquete: " + paqueteMeta.nombre)
    }

    cancelarEdicionPaquete = () => {
        this.setState({
            mostrarDatosPaquete: false,
            nombrePaquete: '',
            indicesSeleccionadosPaquete: [],
            paqueteEditadoId: null
        });
    };

    eliminarPaqueteCompleto = (paqueteId) => {
        // Elimina el paquete Y sus insumos
        Modal.confirm({
            title: '¿Eliminar paquete completo?',
            content: 'Se borrarán los insumos contenidos en este paquete.',
            onOk: () => {
                const insumos = this.formRef.current.getFieldValue('insumos');
                const nuevosInsumos = insumos.filter(item => item._paqueteId !== paqueteId);
                
                const nuevosPaquetesMeta = this.state.paquetes.filter(p => p.idInterno !== paqueteId);

                this.formRef.current.setFieldsValue({ insumos: nuevosInsumos });
                this.setState({ paquetes: nuevosPaquetesMeta });
                message.success("Paquete eliminado.");
            }
        });
    };

    desagruparPaquete = (paqueteId) => {
        const insumos = this.formRef.current.getFieldValue('insumos') || [];
        
        // Usamos la utilidad
        const nuevosInsumosOrdenados = reordenarAlDesagrupar(insumos, paqueteId);
        
        const nuevosPaquetesMeta = this.state.paquetes.filter(p => p.idInterno !== paqueteId);

        this.formRef.current.setFieldsValue({ insumos: nuevosInsumosOrdenados });
        this.setState({ paquetes: nuevosPaquetesMeta });
        message.success("Paquete desagrupado.");
    };

    //Funcion que activa el modo de desglose para los insumos al imprimirse el PDF de la cotización
    toggleImprimirDesglose = (paqueteId) => {
        const { paquetes } = this.state;
        const nuevosPaquetes = paquetes.map(p => {
            if (p.idInterno === paqueteId) {
                return { ...p, imprimirDesglose: !p.imprimirDesglose };
            }
            return p;
        });
        this.setState({ paquetes: nuevosPaquetes });
    };

    //Activad el desglose para todos los paquetes
    toggleImprimirDesgloseGlobal = (activar) => {
        const {paquetes} = this.state; 
        const nuevosPaquetes = paquetes.map(p=> ({ ...p, imprimirDesglose: activar})); 
        this.setState({paquetes: nuevosPaquetes}); 
        message.success(activar ? "Desglose activado para todos los paquetes" : "Desglose desactivado para todos los paquetes.");
    }


     onChangeCantidadPaquete = async (paqueteId, nuevaCantidad) => {
        if (!nuevaCantidad || nuevaCantidad < 1) return;

        const paqueteActual = this.state.paquetes.find(p => p.idInterno === paqueteId);
        const cantidadAnteriorDelPaquete = paqueteActual ? (paqueteActual.cantidad || 1) : 1;

        const nuevosPaquetes = this.state.paquetes.map(p => 
            p.idInterno === paqueteId ? { ...p, cantidad: nuevaCantidad } : p
        );
        this.setState({ paquetes: nuevosPaquetes });

        const insumos = this.formRef.current.getFieldValue('insumos');

        const insumosConNuevaCantidad = insumos.map((item) => {
            if (item._paqueteId === paqueteId) {
                const cantidadBaseUnitario = (item.cantidad || 0) / cantidadAnteriorDelPaquete;
                
                const cantidadCalculada = cantidadBaseUnitario * nuevaCantidad;

                return {
                    ...item,
                    cantidad: cantidadCalculada
                };
            }
            return item;
        });

        this.formRef.current.setFieldsValue({ insumos: insumosConNuevaCantidad });

        insumosConNuevaCantidad.forEach((item, index) => {
            if (item._paqueteId === paqueteId) {
                this.onChangePrecioCantidadDescuento(undefined, index);
            }
        });

        this.setState({});
    }  

    async consultarDatosEquipoMedico() {
    this.setState({ loading: true })
    await axios
        .post(
        "ventas/selectDatosParaEquipoMedico",
        { empresaId: this.props.empresaId },
        {
            headers: this.props.headersToken,
        }
        )
        .then((res) => {
        if (res.data.success === 2) {
            this.setState({
            loading: false,
            todasDoctores: res.data.doctores,
            todasPacientes: res.data.pacientes,
            todasCirugias: res.data.cirugias,
            objetoDoctores: res.data.doctores.map((value) => {
                return (
                <Option value={value._id} key={value._id}>
                    {value.codigo + ' - ' + value.nombre}
                </Option>
                );
            }),
            objetoPacientes: res.data.pacientes.map((value) => {
                return (
                <Option value={value._id} key={value._id}>
                    {value.codigo + ' - ' + value.nombre}
                </Option>
                );
            }),
            objetoCirugias: res.data.cirugias.map((value) => {
                return (
                <Option value={value._id} key={value._id}>
                    {value.codigo + ' - ' + value.nombre}
                </Option>
                );
            }),
            });
        } else {
            message.error('No se encontraron datos de equipo medico')
        }
        });
    }
    
    abrirAgregarCirugia(value) {
        this.setState({
        modalAgregarCirugia: true,
        })
    }

    cerrarAgregarCirugia(value) {
        this.setState({
        modalAgregarCirugia: false,
        })
        this.consultarDatosEquipoMedico()
    }

    abrirAgregarDoctor(value) {
        this.setState({
        modalAgregarDoctor: true,
        })
    }

    cerrarAgregarDoctor(value) {
        this.setState({
        modalAgregarDoctor: false,
        })
        this.consultarDatosEquipoMedico()
    }

    abrirAgregarPaciente(value) {
        this.setState({
        modalAgregarPaciente: true,
        })
    }

    cerrarAgregarPaciente(value) {
        this.setState({
        modalAgregarPaciente: false,
        })
        this.consultarDatosEquipoMedico()
    }

    moverInsumo = (fromIndex, toIndex, moveAntd) => {
        moveAntd(fromIndex, toIndex);

        this.setState(prev => {
            const nuevosTipos = { ...prev.tiposDescuento };
            const temp = nuevosTipos[fromIndex];
            nuevosTipos[fromIndex] = nuevosTipos[toIndex];
            nuevosTipos[toIndex] = temp;
            return { tiposDescuento: nuevosTipos };
        });

        this.setState({});
        // fueraDeRango va indexado por posicion: al reordenar es mas simple volver
        // a revisar todo que remapear el objeto.
        this.reglas.revisarTodas();
    };

    handleDireccionEntregaChange(direccionValues) {
        // Callback desde TabEntregaDireccion cuando se guardan cambios en el modal
        if (direccionValues) {
            this.formRef.current?.setFieldsValue({
                direccionEntrega: direccionValues
            });
            this.setState({ 
                direccionEntregaData: direccionValues 
            });
        }
    }

    // Método para obtener las columnas de la tabla de insumos
    getInsumosColumns() {
        const { mostrarImprimirImagen } = this.state;
        const hayInsumos = this.formRef?.current?.getFieldValue('insumos')?.length > 0;
        
        // Verificar si hay al menos un insumo que permita cargar imágenes
        const insumosActuales = this.formRef?.current?.getFieldValue('insumos') || [];
        const hayInsumoConImagen = insumosActuales.some(item => {
            if (!item || !item.insumoId) return false;
            const insumoOriginal = this.state.todasInsumos.find(i => i._id === item.insumoId);
            
            const tieneImagenes = insumoOriginal?.archivosPrincipal?.length > 0;
            const esCambio = insumoOriginal?.insumoCambio;
            
            return tieneImagenes && !esCambio;
        });


        const habilitarCancelar = insumosActuales.some(item => {
            if (!item || !item.insumoId) return false;
            const insumoOriginal = this.state.todasInsumos.find(i => i._id === item.insumoId);
            
            const tieneImagenes = insumoOriginal?.archivosPrincipal?.length > 0;
            const esCambio = insumoOriginal?.insumoCambio;
            const cargaManual = item.modoImagen === 'cargar';
            
            return tieneImagenes || esCambio || cargaManual;
        });

        const columns = [];

        columns.push({ title: "#", width: "3%" });

        if (this.state.mostrarDatosPaquete) {
            columns.push({ title: "Paquete", width: "3%" });
        }

        // Escuela: Insumo y Proyecto ceden el ancho de Desc. Cliente para que
        // Subtotal / Impuesto / Total no se encoja.
        const anchoCedidoInsumo = this.props.escuela ? 4 : 0;
        const anchoCedidoProyecto = this.props.escuela ? 2 : 0;

        columns.push(
            { title: "Clave", width: "6%" },
            { title: "Insumo", width: `${(this.state.mostrarDatosPaquete ? 21 : 22) - anchoCedidoInsumo}%` },
            { title: "Unidad", width: "6%" },
            { title: "Proyecto", width: `${11 - anchoCedidoProyecto}%` },
            { title: "PU", width: "8%" },
            { title: "Precio Neto", width: "8%" },
            { title: "Inventario", width: "8%" },
            {
                title: (
                    <FormItem noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                            const arrayInsumos = getFieldValue("insumos") || [];
                            const totalCantidadInsumos = arrayInsumos.reduce(
                                (suma, insumo) => suma + (Number(insumo?.cantidad) || 0),
                                0
                            );
                            return (
                                <>
                                    <div>Cant.</div>
                                    <div style={{ fontWeight: 400, fontSize: '11px', color: '#868585' }}>
                                        Total: {totalCantidadInsumos}
                                    </div>
                                </>
                            );
                        }}
                    </FormItem>
                ),
                width: "8%",
            },
            ...(this.props.escuela
                ? [{ title: (<>Desc. Cliente{' '}<Tooltip title="Descuento predeterminado del cliente. El Desc. Adic. se aplica en cascada sobre lo que queda." mouseEnterDelay={0.5}><span style={{ cursor: 'help', color: '#1890ff', fontSize: '12px' }}>?</span></Tooltip></>), width: "6%" }]
                : []),
            { title: this.props.escuela ? "Desc. Adic." : "Desc.", width: "8%" },
            { title: "Subtotal / Impuesto / Total", width: "13%" },

            {
                title:(
                    <Space>
                      {mostrarImprimirImagen && hayInsumos ? (
                        <>
                            <Tooltip title="Usar imágenes de catálogo (Todos)">
                                <ButtonItem
                                    key="btn-global-img-on"
                                    type="primary"
                                    verde
                                    disabled={!hayInsumoConImagen}
                                    onClick={this.activarImagenesGlobal}
                                    icon={<FileImageOutlined />}
                                    size="small"
                                />
                            </Tooltip>

                            <Tooltip title="Limpiar imágenes (Todos)">
                                <ButtonItem
                                    key="btn-global-img-off"
                                    type="primary"
                                    danger
                                    disabled={!habilitarCancelar}
                                    onClick={this.limpiarImagenesGlobal}
                                    icon={<StopOutlined />}
                                    size="small"
                                />
                            </Tooltip>

                            </>
                            ) : null}
                            { hayInsumos ? (
                                <Tooltip title={this.state.modoReordenar ? "Terminar de reordenar" : "Reordenar insumos"}>
                                    <ButtonItem
                                        key="btn-reordenar"
                                        type={this.state.modoReordenar ? "primary" : "default"}
                                        onClick={() => this.setState({ modoReordenar: !this.state.modoReordenar })}
                                        icon={<SwapOutlined rotate={90} />}
                                        size="small"
                                        morado={this.state.modoReordenar}
                                        blanco={!this.state.modoReordenar}
                                        lessTime
                                    />
                                </Tooltip>
                            ) : null}
                        </Space>
                    ),
                width: "17%",
                fixed: "right",
            }
        );

        return columns;
    }

      // Método para renderizar cada fila de la tabla de insumos
    renderInsumoRow({ key, name, fieldKey, restField, arrayKey, remove, move }) {
        const insumosValues = this.formRef.current?.getFieldValue('insumos') || [];

        const estadoFila = {
            empresaId: this.props.empresaId,
            headersToken: this.props.headersToken,
            clienteId: this.formRef.current?.getFieldValue("clienteId"),
            usarPrecioCliente: this.formRef.current?.getFieldValue("usarPrecioCliente"),
            autorizacionesRapidas: this.props.autorizacionesRapidas,
            paquetes: this.state.paquetes,
            mostrarDatosPaquete: this.state.mostrarDatosPaquete,
            indicesSeleccionadosPaquete: this.state.indicesSeleccionadosPaquete,
            paqueteEditadoId: this.state.paqueteEditadoId,
            todasInsumos: this.state.todasInsumos,
            mostrarImprimirImagen: this.state.mostrarImprimirImagen,
            objetoProyectos: this.state.objetoProyectos,
            permisos: {
                permisoModificarPrecioUnitario: this.props.permisoModificarPrecioUnitario,
                permisoModificarDescuento: this.props.permisoModificarDescuento,
            },
            autorizacionesFila: this.state.autorizacionesActivas,
            fueraDeRango: this.state.fueraDeRango,
            modoReordenar: this.state.modoReordenar,
            totalFilas: insumosValues.length,
        };

        const funcionesFila = {
            editarPaquete: this.editarPaquete,
            toggleImprimirDesglose: this.toggleImprimirDesglose,
            desagruparPaquete: this.desagruparPaquete,
            eliminarPaqueteCompleto: this.eliminarPaqueteCompleto,
            onChangeCantidadPaquete: this.onChangeCantidadPaquete,
            onCheckInsumoPaquete: this.onCheckInsumoPaquete,
            onChangeInsumoProyecto: this.onChangeInsumoProyecto,
            onChangePrecioCantidadDescuento: this.onChangePrecioCantidadDescuento,
            abrirVerInsumo: this.abrirVerInsumo,
            seleccionarModoImagen: this.seleccionarModoImagen,
            abrirVistaPreviaInsumo: this.abrirVistaPreviaInsumo,
            abrirModalImagen: this.abrirModalImagen,
            abrirLeyenda: this.abrirLeyenda,
            abrirElegirMarbetes: this.abrirElegirMarbetes,
            abrirElegirLotes: this.abrirElegirLotes,
            abrirElegirAgrupaciones: this.abrirElegirAgrupaciones,
            abrirObservaciones: this.abrirObservaciones,
            toggleDescripcionLarga: this.toggleDescripcionLarga,
            onDobleClickDescuento: this.onDobleClickDescuento,
            onChangeDescuentoEscuela: this.onChangeDescuentoEscuela,
            onChangePrecioConImpuestos: this.onChangePrecioConImpuestos,
            abrirDisponibilidad: this.abrirDisponibilidad,
            abrirHistorialCliente: this.abrirHistorialCliente,
            abrirDetalleInsumo: this.abrirDetalleInsumo,
            abrirModalAutorizacion: this.abrirModalAutorizacion,
            remove,
            move: (from, to) => this.moverInsumo(from, to, move),
        };

        return (
            <FilaInsumoCotizacion
                key={key}
                field={{ key, name, fieldKey, ...restField }}
                index={arrayKey}
                form={this.formRef.current}
                insumosValues={insumosValues}
                estado={estadoFila}
                funciones={funcionesFila}
                tiposDescuento={this.state.tiposDescuento}
                modoLectura={false}
                escuela={!!this.props.escuela}
            />
        );
    }

  
    // Método para renderizar el contenido del tab Entrega
    renderEntregaContent() {
        return (
            <TabEntregaDireccion
                key={`direccion-${this.state.direccionesCliente?.[0]?._id || 'no-cliente'}`}
                loadingEntrega={this.state.loadingEntrega}
                clienteDireccion={this.state.direccionesCliente?.[0]}
                objetoDireccionesCliente={this.state.objetoDireccionesCliente}
                handleChangeDireccionEntrega={this.handleChangeDireccionEntrega.bind(this)}
                onDireccionChange={this.handleDireccionEntregaChange.bind(this)}
                formInstance={this.formRef.current}
                loadingPlantasEntrega={this.state.loadingPlantasEntrega}
                objetoPlantasEntrega={this.state.objetoPlantasEntrega}
                onSearchPlantaEntrega={this.onSearchPlantaEntrega?.bind(this)}
                objetoColonias={this.state.objetoColonias}
                onSearchColonia={this.onSearchColonia.bind(this)}
                onSelectColoniaId={this.onSelectColoniaId.bind(this)}
                objetoMunicipios={this.state.objetoMunicipios}
                onChangeMunicipio={this.onChangeMunicipio.bind(this)}
                objetoEstados={this.state.objetoEstados}
                onChangeEstado={this.onChangeEstado.bind(this)}
                objetoPaises={this.state.objetoPaises}
                addendaMabe={this.state.addendaMabe}
            />
        );
    }

    getObservacionesConfig() {
    return {
        observaciones: {
            value: this.formRef.current?.getFieldValue('observaciones') || '',
            onSave: (value) => {
                this.formRef.current?.setFieldsValue({ observaciones: value });
                this.forceUpdate(); 
            },
            disabled: false
        },
        observaciones2: {
            value: this.formRef.current?.getFieldValue('observaciones2') || '',
            onSave: (value) => {
                this.formRef.current?.setFieldsValue({ observaciones2: value });
                this.forceUpdate(); 
            },
            disabled: false
        },
        checkboxes: [
            ...(this.props.quitarImpuestosOpcionalVentas ? [{
                name: 'quitarImpuestos',
                label: 'Quitar Impuestos',
                onChange: (e) => {
                    this.setState({ quitarImpuestos: e.target.checked }, () => {
                        const insumos = this.formRef.current.getFieldValue("insumos");
                        if (insumos?.length) this.recalcularInsumosEnBatch(insumos);
                    });
                }
            }] : []),
            {
                name: 'imprimirObservaciones',
                label: 'Imprimir Observaciones',
                onChange: null
            },
            {
                name: 'deshabilitarBanco',
                label: 'Deshabilitar Banco',
                onChange: null
            }
        ],
        totales: (
            <FormItem shouldUpdate noStyle>
                {({ getFieldValue }) => {
                    let arrayInsumos = getFieldValue("insumos") || [];
                    let arrayRetenciones = [];
                    let cuentasCliente = 0;
                    let subtotal = 0;
                    let arrayImpuestos = [];
                    let total = 0;

                    arrayInsumos.map((value) => {
                        if (value) {
                            if (
                                value.subtotal &&
                                value.total &&
                                value.arrayImpuestos
                            ) {
                                subtotal += value.subtotal;
                                total += value.subtotal;
                                value.arrayImpuestos.map((valueImpuestos) => {
                                    let index = arrayImpuestos.findIndex(
                                        (valueImpuestosAnterios) =>
                                            valueImpuestosAnterios.descripcionFactura ===
                                            valueImpuestos.descripcionFactura
                                            &&
                                            valueImpuestosAnterios.tasaCuota ===
                                            valueImpuestos.tasaCuota
                                            &&
                                            valueImpuestosAnterios.impuesto ===
                                            valueImpuestos.impuesto
                                    );
                                    if (index !== -1) {
                                        let newItem = {
                                            totalImpuestos:
                                                arrayImpuestos[index].totalImpuestos +
                                                valueImpuestos.totalImpuestos,
                                            baseImpuesto:
                                                arrayImpuestos[index].baseImpuesto +
                                                valueImpuestos.baseImpuesto,
                                            descripcionFactura:
                                                valueImpuestos.descripcionFactura,
                                            tasaCuota:
                                                valueImpuestos.tasaCuota,
                                            impuesto:
                                                valueImpuestos.impuesto,
                                            montoImpuesto:
                                                valueImpuestos.montoImpuesto,
                                            local: valueImpuestos.local,
                                        };
                                        arrayImpuestos.splice(index, 1, newItem);
                                    } else {
                                        arrayImpuestos.push({
                                            tasaCuota: valueImpuestos.tasaCuota,
                                            impuesto: valueImpuestos.impuesto,
                                            local: valueImpuestos.local,
                                            montoImpuesto: valueImpuestos.montoImpuesto,
                                            baseImpuesto: valueImpuestos.baseImpuesto,
                                            descripcionFactura: valueImpuestos.descripcionFactura,
                                            totalImpuestos: valueImpuestos.totalImpuestos,
                                        });
                                    }
                                    return null;
                                });
                                if (value.arrayRetenciones) {
                                    value.arrayRetenciones.map((valueRetenciones) => {
                                        let index = arrayRetenciones.findIndex(
                                            (valueRetencionesAnterios) =>
                                                valueRetencionesAnterios.descripcionFactura ===
                                                valueRetenciones.descripcionFactura
                                                &&
                                                valueRetencionesAnterios.tasaCuota ===
                                                valueRetenciones.tasaCuota
                                                &&
                                                valueRetencionesAnterios.impuesto ===
                                                valueRetenciones.impuesto
                                        );
                                        cuentasCliente += round2Decimals(valueRetenciones.totalRetenciones);
                                        if (index !== -1) {
                                            let newItem = {
                                                totalRetenciones:
                                                    arrayRetenciones[index].totalRetenciones +
                                                    valueRetenciones.totalRetenciones,
                                                baseRetencion:
                                                    arrayRetenciones[index].baseRetencion +
                                                    valueRetenciones.baseRetencion,
                                                descripcionFactura:
                                                    valueRetenciones.descripcionFactura,
                                                tasaCuota:
                                                    valueRetenciones.tasaCuota,
                                                impuesto:
                                                    valueRetenciones.impuesto,
                                                montoRetencion:
                                                    valueRetenciones.montoRetencion,
                                                local: valueRetenciones.local,
                                            };
                                            arrayRetenciones.splice(index, 1, newItem);
                                        } else {
                                            arrayRetenciones.push({
                                                tasaCuota: valueRetenciones.tasaCuota,
                                                impuesto: valueRetenciones.impuesto,
                                                montoRetencion: valueRetenciones.montoRetencion,
                                                local: valueRetenciones.local,
                                                baseRetencion: valueRetenciones.baseRetencion,
                                                descripcionFactura: valueRetenciones.descripcionFactura,
                                                totalRetenciones: valueRetenciones.totalRetenciones,
                                            });
                                        }
                                        return null;
                                    });
                                }
                            }
                        }
                        return null;
                    });
                    arrayImpuestos = arrayImpuestos.map(valueImpuesto => {
                        total += round2Decimals(valueImpuesto.totalImpuestos)
                        return {
                            ...valueImpuesto,
                            totalImpuestos: round2Decimals(valueImpuesto.totalImpuestos),
                        }
                    })
                    if (this.state.totalPagar !== (total - cuentasCliente)) {
                        this.setState({ totalPagar: (total - cuentasCliente) });
                    }
                    const totalCantidadInsumos = arrayInsumos.reduce(
                        (suma, insumo) => suma + (Number(insumo?.cantidad) || 0),
                        0
                    );
                    return (
                        <table className="table" style={{ marginTop: 0 }}>
                            <tbody>
                                <tr>
                                    <th
                                        className="th-totales"
                                        style={{ width: "50%" }}
                                    >
                                        Total Insumos
                                    </th>
                                    <td
                                        className="td-totales-right"
                                        style={{ width: "50%" }}
                                    >
                                        {totalCantidadInsumos}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <th
                                        className="th-totales"
                                        style={{ width: "50%" }}
                                    >
                                        Subtotal
                                    </th>
                                    <td
                                        className="td-totales-right"
                                        style={{ width: "50%" }}
                                    >
                                        {dineroDisabledMask(subtotal)}
                                    </td>
                                </tr>
                            </tbody>
                              {arrayImpuestos.map((valueArray) => (
                                <tbody>
                                    <tr key={valueArray.descripcionFactura}>
                                        <th className="th-totales">
                                            {valueArray.descripcionFactura}
                                        </th>
                                        <td className="td-totales-right">
                                            {dineroDisabledMask(
                                                valueArray.totalImpuestos
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            ))}
                            <tbody>
                                <tr>
                                    <th className="th-totales">Total</th>
                                    <td className="td-totales-right">
                                        {dineroDisabledMask(total)}
                                    </td>
                                </tr>
                            </tbody>
                            {arrayRetenciones.map((value) => (
                                <tbody>
                                    <tr>
                                        <th className="th-totales">
                                            {value.descripcionFactura}
                                        </th>
                                        <td className="td-totales-right">
                                            {dineroDisabledMask(value.totalRetenciones)}
                                        </td>
                                    </tr>
                                </tbody>
                            ))}
                            <tbody>
                                <tr>
                                    <th className="th-totales">Total a Pagar</th>
                                    <td className="td-totales-right">
                                        {dineroDisabledMask(total - cuentasCliente)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    );
                }}
            </FormItem>
        )
    };
    }

    render() {

        const isMobile = window.innerWidth <= 1000;

        let archivosFilaActual = [];
        let cantidadImagenesInsumo = 0;
        let esInsumoCambio = false;

        if (this.state.indiceFilaImagen !== null) {
            const insumosForm = this.formRef.current?.getFieldValue('insumos');
            if (insumosForm && insumosForm[this.state.indiceFilaImagen]) {
                archivosFilaActual = insumosForm[this.state.indiceFilaImagen].archivosCargados || [];

                const insumoId = insumosForm[this.state.indiceFilaImagen].insumoId;
                const insumoOriginal = this.state.todasInsumos.find(i => i._id === insumoId);

                if (insumoOriginal && insumoOriginal.archivosPrincipal) {
                    cantidadImagenesInsumo = insumoOriginal.archivosPrincipal.length;
                }

                if (insumoOriginal) {
                    esInsumoCambio = insumoOriginal.insumoCambio;
                }
            }
        }

        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title="Agregar Cotización"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                />
                {this.preCotizacionIdOrigen && (
                    <Alert
                        type="info"
                        showIcon
                        style={{ marginBottom: 10 }}
                        message={`Esta cotización quedará ligada a la pre cotización${
                            this.state.preCotizacionOrigen
                                ? ` ${this.state.preCotizacionOrigen.serie || ""} ${this.state.preCotizacionOrigen.numero || ""}`
                                : ""
                        }`}
                        description={
                            this.state.preCotizacionOrigen
                                ? [
                                    this.state.preCotizacionOrigen.nombreProyecto
                                        ? `Proyecto: ${this.state.preCotizacionOrigen.nombreProyecto}`
                                        : null,
                                    this.state.preCotizacionOrigen.cliente
                                        ? `Cliente en la pre cotización: ${this.state.preCotizacionOrigen.cliente}`
                                        : null,
                                ].filter(Boolean).join(" · ") || undefined
                                : undefined
                        }
                    />
                )}
                <div className="card-background" style={{ paddingTop: 0 }}>
                    <Spin
                        spinning={this.state.loading}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                        <Form
                            ref={this.formRef}
                            name="agregarCotizacion"
                            layout
                            onValuesChange={() => this.setState({})}

                            onFinish={(values) =>
                                this.setState({ modalConfirmacion: true, valuesForm: values })
                            }
                            onFinishFailed={this.onFinishFailed}
                        >
                            <FormItem noStyle shouldUpdate={(prev, curr) =>
                                prev.insumos?.length !== curr.insumos?.length ||
                                prev.contado !== curr.contado ||
                                prev.factura !== curr.factura
                            }>
                            {({ getFieldValue }) => {
                                const insumos = getFieldValue("insumos");
                                const disabled = insumos && insumos.length > 0 ? true : false;
                                const contado = getFieldValue("contado");
                                const factura = getFieldValue("factura");
                                let showFormaDePago;
                                if ((contado === 1 && factura !== 1) || contado === 1) {
                                    showFormaDePago = false;   // Contado + Remisión ó contado sin factura
                                } else {
                                    showFormaDePago = true;    // Factura O Crédito
                                }
                                return (
                            <VentasForm
                                formInstance={this.formRef.current}
                                isMobile={isMobile}
                                showFormaDePago={showFormaDePago}
                                datosGeneralesCol={{ xs: 24, sm: 24, md: 24, lg: 18, xl: 18 }}
                                monedaCol={{ xs: 24, sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }}

                                // Contenido de Datos Generales
                                datosGeneralesContent={(
                                                <>
                                                   
                                                    <Row gutter={[16, 8]} align="top">
                                                        <Col xs={24} sm={24} md={14} lg={14}>
                                                          <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
                                                             <div style={{ flex: 1, minWidth: 0 }}>
                                                                <FormItem
                                                                    label="Cliente"
                                                                    name="clienteId"
                                                                    required
                                                                    margin
                                                                    labelCol={{ span: 6 }} wrapperCol={{ span: 18}}
                                                                >
                                                                    <SelectClientesItem
                                                                        empresaId={this.props.empresaId}
                                                                        headersToken={this.props.headersToken}
                                                                        autoFocus
                                                                        sinBorde
                                                                        dropdownMatchSelectWidth={600}
                                                                        width="100%"
                                                                        placeholder="Cliente"
                                                                        onChange={(valueId, cliente) => this.onChangeCliente(valueId, cliente)}
                                                                    />
                                                                </FormItem>
                                                            </div>

                                                                <ButtonItem
                                                                    type="primary"
                                                                    icon={<PlusOutlined />}
                                                                    disabled={disabled}
                                                                    onClick={this.abrirAgregarCliente}
                                                                />
                                                        </div>

                                                            {/* Leyenda */}
                                                            {this.state.leyenda && (
                                                                <Row align="middle" style={{ marginTop: 4 }}>
                                                                    <Col span={23}>
                                                                        <Row align="middle">
                                                                            <Col span={4} style={{ textAlign: 'right', paddingRight: 8 }}>
                                                                                <FormItem
                                                                                    name="leyenda"
                                                                                    valuePropName="checked"
                                                                                    initialValue={false}
                                                                                    noStyle
                                                                                >
                                                                                    <Checkbox onChange={this.handleCheckboxChange}>
                                                                                        <span style={{ fontSize: '14px', fontWeight: 500 }}>
                                                                                            Leyenda:
                                                                                        </span>
                                                                                    </Checkbox>
                                                                                </FormItem>
                                                                            </Col>
                                                                            <Col span={20}>
                                                                                {this.state.leyendaActiva && (
                                                                                    <FormItem
                                                                                        name="leyendaCliente"
                                                                                        noStyle
                                                                                    >
                                                                                        <InputItem placeholder="Escribe la leyenda aquí" />
                                                                                    </FormItem>
                                                                                )}
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col span={1} />
                                                                </Row>
                                                            )}
                                                        </Col>

                                                        {/* Fecha */}
                                                        <Col xs={12} sm={8} md={10} lg={10}>
                                                            <FormItem
                                                                label="Fecha:"
                                                                name="fechaCotizacion"
                                                                required
                                                                margin
                                                                initialValue={moment()}
                                                                labelCol={{ span: 8 }}
                                                                wrapperCol={{ span: 16 }}
                                                            >
                                                                <DatePickerItem
                                                                    placeholder="Fecha de Cotización"
                                                                    allowClear={false}
                                                                />
                                                            </FormItem>
                                                        </Col>

                                                    </Row>

                                                    <Row gutter={[16, 8]}>

                                                        <Col xs={24} sm={24} md={14} lg={14}>
                                                            <FormItem
                                                                label="Vendedor"
                                                                name="vendedorId"
                                                                required
                                                                margin
                                                                initialValue={this.props.usuarioId}
                                                                labelCol={{ span: 6 }} wrapperCol={{ span: 18}}
                                                            >
                                                                <SelectItem placeholder="Vendedor" disabled={this.props.permisoBloquearVendedorCotizacion}>
                                                                    {this.state.objetoUsuarios}
                                                                </SelectItem>
                                                            </FormItem>
                                                        </Col>
                                                        {/* Método */}
                                                        <Col xs={12} sm={8} md={10} lg={10}>
                                                            <FormItem
                                                                label="Método"
                                                                name="contado"
                                                                initialValue={1}
                                                                required
                                                                margin
                                                                labelCol={{ span: 8 }}
                                                                wrapperCol={{ span: 10 }}
                                                            >
                                                                <SelectItem onChange={this.onChangeContado.bind(this)} disabled={!this.props.permisoVenderCredito}>
                                                                    <Option value={1}>Contado - PUE</Option>
                                                                    <Option value={2}>Crédito - PPD</Option>
                                                                </SelectItem>
                                                            </FormItem>
                                                        </Col>
                                                    </Row>

                                                    <Row gutter={[16, 8]} align="middle">
                                                        <Col xs={24} sm={12} md={14} lg={14}>
                                                            <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                    <FormItem
                                                                        name="canalDeVentaId"
                                                                        margin
                                                                        label="Canal"
                                                                        labelCol={{ span: 6 }}
                                                                        wrapperCol={{ span: 18 }}
                                                                    >
                                                                        <SelectItem placeholder="Canal de Venta" width="100%">
                                                                        {this.state.objetoCanalesVenta}
                                                                        </SelectItem>
                                                                    </FormItem>
                                                                </div>
                                                                <ButtonItem
                                                                    type="primary"
                                                                    icon={<PlusOutlined />}
                                                                    onClick={this.abrirAgregarCanal}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                </>
                                )}

                                 datosVentaContent={
                                    <FormItem
                                        noStyle
                                        shouldUpdate={(prev, curr) =>
                                            prev.insumos?.length !== curr.insumos?.length ||
                                            prev.factura !== curr.factura ||
                                            prev.clienteId !== curr.clienteId
                                        }
                                    >
                                        {({ getFieldValue }) => {
                                            const insumos = getFieldValue("insumos");
                                            const disabled = insumos && insumos.length > 0 ? true : false;
                                            const clienteIdActual = getFieldValue("clienteId");
                                            const clienteActual = this.state.todasClientes?.find((c) => c._id === clienteIdActual);
                                            return (
                                                <>
                                                      {/* Precio */}
                                                        <Col xs={24} sm={24} md={24} lg={24}>
                                                            <div style={{ display: "flex", alignItems: "flex-end", gap: 6 }}>
                                                                <FormItem
                                                                    name="precioId"
                                                                    label="Precio"
                                                                    required
                                                                    margin
                                                                    labelCol={{ span: 8 }}
                                                                    wrapperCol={{ span: 16 }}
                                                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                                                >
                                                                    <SelectItem
                                                                        placeholder="Precio"
                                                                        disabled={this.estaBloqueado("listaPrecios")}
                                                                        onChange={(value) => this.onChangePrecioId(value)}
                                                                    >
                                                                        {this.state.objetoPrecios}
                                                                    </SelectItem>
                                                                </FormItem>
                                                                <BotonAutorizacion
                                                                    visible={this.props.autorizacionesRapidas && this.estaBloqueado("listaPrecios")}
                                                                    onClick={() => this.abrirModalAutorizacion("listaPrecios")}
                                                                />
                                                            </div>
                                                        </Col>
                                                        {clienteActual?.empresaAlterna?.activo && (
                                                        <Col xs={24} sm={24} md={24} lg={24}>
                                                            <FormItem
                                                                name="usarEmpresaAlterna"
                                                                label="Usar Empresa Alterna"
                                                                valuePropName="checked"
                                                                initialValue={true}
                                                                margin
                                                                specialLayoutSwitch
                                                            >
                                                                <SwitchItem />
                                                            </FormItem>
                                                        </Col>
                                                        )}
                                                        {this.props.insumosXClienteEmpresa && clienteActual?.insumosXCliente && (
                                                        <Col xs={24} sm={24} md={24} lg={24}>
                                                            <FormItem
                                                                name="usarPrecioCliente"
                                                                label="Usar Precios del Cliente"
                                                                valuePropName="checked"
                                                                initialValue={true}
                                                                margin
                                                                specialLayoutSwitch
                                                            >
                                                                <SwitchItem onChange={(checked) => this.onChangeUsarPrecioCliente(checked)} />
                                                            </FormItem>
                                                        </Col>
                                                        )}

                                                        {/* Proyecto */}
                                                       <Col xs={24} sm={24} md={24} lg={24}>
                                                            <FormItem
                                                                name="proyectoId"
                                                                label="Proyecto"
                                                                required
                                                                margin
                                                                labelCol={{ span: 8 }}
                                                                wrapperCol={{ span: 16 }}
                                                            >
                                                                <SelectItem placeholder="Proyecto" disabled={disabled}>
                                                                    {this.state.objetoProyectos}
                                                                </SelectItem>
                                                            </FormItem>
                                                        </Col>

                                                        {/* Fecha Vigencia */}
                                                        <Col xs={24} sm={24} md={24} lg={24}>
                                                            <FormItem
                                                                label="F. Vig"
                                                                name="fechaVigencia"
                                                                margin
                                                                initialValue={moment().add(15, 'days')}
                                                                labelCol={{ span: 8 }}
                                                                wrapperCol={{ span: 16 }}
                                                            >
                                                                <DatePickerItem
                                                                    placeholder="Fecha Vigencia"
                                                                    allowClear
                                                                />
                                                            </FormItem>
                                                        </Col>
                                                    
                                                </>
                                            );
                                        }}
                                    </FormItem>
                                }

                                datosClienteContent={(
                                    <>
                                        <Row gutter={[16, 8]}>
                                            <Col span={24}>
                                                <FormItem
                                                    name="ordenDeCompra"
                                                    label="O Compra"
                                                    margin
                                                    pattern
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                >
                                                    <InputItem placeholder="Orden de Compra" />
                                                </FormItem>
                                            </Col>

                                            <Col span={24}>
                                                <FormItem
                                                    name="req"
                                                    label="Req"
                                                    margin
                                                    pattern
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                >
                                                    <InputItem placeholder="Requisición" />
                                                </FormItem>
                                            </Col>

                                            <Col span={24}>
                                                <FormItem
                                                    pattern
                                                    name='atencion'
                                                    label='Atención a'
                                                    margin
                                                    tooltip="Indica a quién dirigir este documento."
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                >
                                                    <InputItem />
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </>
                                )}

                                extrasContent={(
                                    <Row gutter={[16, 8]}>
                                        <Col span={24}>
                                            <FormItem
                                                name="fechaEntregaEstimada"
                                                label="F. Entrega Est."
                                                margin
                                                labelCol={{ span: 8 }}
                                                wrapperCol={{ span: 16 }}
                                            >
                                                <DatePickerItem placeholder="Fecha de entrega estimada" />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                )}

                                // Contenido de Forma de Pago
                                formaDePagoContent={(
                                    <FormItem
                                        noStyle
                                        shouldUpdate={(prev, curr) =>
                                            prev.contado !== curr.contado ||
                                            prev.factura !== curr.factura
                                        }
                                    >
                                        {({ getFieldValue }) => {
                                            const contado = getFieldValue("contado");
                                            const factura = getFieldValue("factura");

                                            const diasCredito =
                                                contado !== 1 ? (
                                                    <FormItem
                                                        label="Días de crédito"
                                                        name="diasCredito"
                                                        numberCero
                                                        margin
                                                        required
                                                        initialValue={0}
                                                        labelCol={{ span: 9 }}
                                                        wrapperCol={{ span: 16 }}
                                                    >
                                                        <InputNumberItem placeholder="Días de Crédito" />
                                                    </FormItem>
                                                ) : null;

                                            const usoCFDI =
                                                factura === 1 ? (
                                                    <FormItem
                                                        name="usoDeCfdiId"
                                                        label="Uso de CFDI"
                                                        margin
                                                        required
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                    >
                                                        <SelectItem placeholder="Uso de CFDI">
                                                            {this.state.objetoUsosDeCFDI}
                                                        </SelectItem>
                                                    </FormItem>
                                                ) : null;

                                            // Si no hay nada que mostrar, retornar null para ocultar la card
                                            if (!usoCFDI && !diasCredito) {
                                                return null;
                                            }

                                            return (
                                                <>
                                                    {usoCFDI}
                                                    {diasCredito}
                                                </>
                                            );
                                        }}
                                    </FormItem>
                                )}

                               

                                doctorContent={this.props.equipoMedico ? (
                                <>
                                    <Row gutter={[16, 8]}>

                                    {/* DOCTOR */}
                                    <Col xs={24} sm={24} md={20} lg={20}>
                                        <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'baseline',
                                            gap: 4,
                                            flexWrap: 'wrap'
                                        }}
                                        >
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <FormItem
                                            name="doctorId"
                                            label="Doctor:"
                                            labelCol={{ span: 8 }}
                                            wrapperCol={{ span: 16 }}
                                            margin
                                            required={this.state.docObligatorio}
                                            >
                                            <SelectItem placeholder="Doctor">
                                                {this.state.objetoDoctores}
                                            </SelectItem>
                                            </FormItem>
                                        </div>

                                        <ButtonItem
                                            type="primary"
                                            icon={<PlusOutlined />}
                                            style={{ flexShrink: 0, height: 32 }}
                                            onClick={this.abrirAgregarDoctor.bind(this)}
                                        />
                                        </div>
                                    </Col>

                                    {/* PACIENTE */}
                                    <Col xs={24} sm={24} md={20} lg={20}>
                                        <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'baseline',
                                            gap: 4,
                                            flexWrap: 'wrap'
                                        }}
                                        >
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <FormItem
                                            name="pacienteId"
                                            label="Paciente:"
                                            labelCol={{ span: 8 }}
                                            wrapperCol={{ span: 16 }}
                                            margin
                                            >
                                            <SelectItem placeholder="Paciente">
                                                {this.state.objetoPacientes}
                                            </SelectItem>
                                            </FormItem>
                                        </div>

                                        <ButtonItem
                                            type="primary"
                                            icon={<PlusOutlined />}
                                            style={{ flexShrink: 0, height: 32 }}
                                            onClick={this.abrirAgregarPaciente.bind(this)}
                                        />
                                        </div>
                                    </Col>

                                    {/* CIRUGÍA */}
                                    <Col xs={24} sm={24} md={20} lg={20}>
                                        <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'baseline',
                                            gap: 4,
                                            flexWrap: 'wrap'
                                        }}
                                        >
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <FormItem
                                            name="cirugiaId"
                                            label="Cirugía:"
                                            labelCol={{ span: 8 }}
                                            wrapperCol={{ span: 16 }}
                                            margin
                                            >
                                            <SelectItem placeholder="Cirugia">
                                                {this.state.objetoCirugias}
                                            </SelectItem>
                                            </FormItem>
                                        </div>

                                        <ButtonItem
                                            type="primary"
                                            icon={<PlusOutlined />}
                                            style={{ flexShrink: 0, height: 32 }}
                                            onClick={this.abrirAgregarCirugia.bind(this)}
                                        />
                                        </div>
                                    </Col>

                                    </Row>
                                </>
                                ) : null}



                                // Contenido Moneda
                                monedaContent={(
                                    <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId || prev.insumos?.length !== curr.insumos?.length}>
                                        {({ getFieldValue }) => {
                                            const insumos = getFieldValue("insumos");
                                            const disabled = insumos && insumos.length > 0;
                                            const monedaId = getFieldValue('monedaId');
                                            return (
                                                <>
                                                    <FormItem
                                                        required
                                                        margin
                                                        name="monedaId"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 24 }}
                                                        initialValue='60c7e4396465ad440c41c15a'
                                                    >
                                                        <SelectItem disabled={disabled} onChange={(value) => {
                                                            if (value === '60c7e4396465ad440c41c15a') {
                                                                this.formRef.current.setFieldsValue({ tipoDeCambio: 1 })
                                                            } else {
                                                                this.onChangeMoneda(value)
                                                            }
                                                        }} placeholder="Moneda">
                                                            {this.state.objetoMonedas}
                                                        </SelectItem>
                                                    </FormItem>
                                                    {/* Tipo de Cambio - Solo si NO es MXN */}
                                                    {monedaId !== '60c7e4396465ad440c41c15a' ? (
                                                        <FormItem
                                                            required
                                                            number
                                                            margin
                                                            label="T. Cambio"
                                                            name="tipoDeCambio"
                                                            type="number"
                                                            initialValue={1}
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                        >
                                                            <InputNumberItem dinero placeholder="T. Cambio" />
                                                        </FormItem>
                                                    ) : (
                                                        <FormItem name="tipoDeCambio" initialValue={1} hidden>
                                                            <InputNumberItem />
                                                        </FormItem>
                                                    )}
                                                </>
                                            );
                                        }}
                                    </FormItem>
                                )}

                                showDoctor={this.props.equipoMedico}
                                showRegimenFiscal={false}
                                showMoneda={true}
                                gutter={[20, 16]}

                                // Tabs para Insumos y Entrega
                                tabs={[
                                    {
                                        key: "tabla",
                                        label: "Insumos",
                                        listName: "insumos",
                                        columns: this.getInsumosColumns(),
                                        renderRow: this.renderInsumoRow.bind(this),
                                        renderHeader: () => {
                                            const insumosActuales = this.formRef.current?.getFieldValue('insumos') || [];
                                            const clienteSeleccionado = this.formRef.current?.getFieldValue('clienteId');
                                            const mostrarControlesPaquete = clienteSeleccionado && insumosActuales.length > 0;
                                            return (
                                                <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
                                                    <PaqueteControls
                                                        configuracionPaquetes={this.state.configuracionPaquetes}
                                                        mostrarControles={mostrarControlesPaquete}
                                                        modoEdicion={this.state.mostrarDatosPaquete}
                                                        paqueteEditadoId={this.state.paqueteEditadoId}
                                                        nombrePaquete={this.state.nombrePaquete}
                                                        setNombrePaquete={(val) => this.setState({ nombrePaquete: val })}
                                                        onGuardar={this.guardarPaquete}
                                                        onCancelar={this.cancelarEdicionPaquete}
                                                        onAgregarNuevo={this.agregarPaquete}
                                                        hayPaquetesCreados={this.state.paquetes.length > 0}
                                                        onToggleGlobalPdf={this.toggleImprimirDesgloseGlobal}
                                                    />
                                                </div>
                                            );
                                        },
                                        renderFooter: ({ add, fields }) => (
                                            <FormItem
                                                noStyle
                                                shouldUpdate={(prev, curr) =>
                                                    prev.proyectoId !== curr.proyectoId ||
                                                    prev.precioId !== curr.precioId ||
                                                    prev.clienteId !== curr.clienteId ||
                                                    prev.monedaId !== curr.monedaId
                                                }
                                            >
                                                {({ getFieldValue }) => {
                                                    const proyectoId = getFieldValue('proyectoId');
                                                    const precioId = getFieldValue('precioId');
                                                    const clienteId = getFieldValue('clienteId');
                                                    const monedaId = getFieldValue('monedaId');
                                                    const tipoDeCambio = getFieldValue('tipoDeCambio');

                                                    // Validación de campos base
                                                    const moneda = this.state.todasMonedas?.find(m => m._id === monedaId);
                                                    const esMXN = moneda && (moneda.nombre === 'MXN' || moneda.nombre === 'Peso Mexicano' || moneda.clave === 'MXN');

                                                    const datosBaseListos =
                                                        proyectoId && precioId && clienteId && monedaId && (esMXN || tipoDeCambio);

                                                    return (
                                                        <div style={{ marginBottom: 6, marginTop: 6, display: 'flex', gap: 8, alignItems: 'center' }}>
                                                        <FormItem noStyle>
                                                            <ButtonItem
                                                                style={{
                                                                    marginTop: 10,
                                                                    marginBottom: 10,
                                                                    justifySelf: fields.length > 0 ? "left" : null,
                                                                    width: fields.length > 0 ? "auto" : null,
                                                                    flex: 1,
                                                                }}
                                                                type="primary"
                                                                cyan
                                                                hotkey="alt+a"
                                                                icon={<PlusOutlined />}
                                                                onClick={
                                                                 datosBaseListos
                                                                    ? () => {
                                                                        if (this.state.cantidadDefault) {
                                                                            add({ cantidad: 1 });
                                                                        } else {
                                                                            add();
                                                                        }
                                                                    }
                                                                    : () =>
                                                                        message.info(
                                                                            "Agregue los datos de venta primero"
                                                                        )
                                                                }
                                                                block
                                                            >
                                                               Agregar Insumo
                                                            </ButtonItem>
                                                        </FormItem>
                                                        <FormItem noStyle>
                                                            <ButtonItem
                                                                style={{ marginTop: 10, marginBottom: 10, flexShrink: 0 }}
                                                                icon={<SearchOutlined />}
                                                                hotkey="alt+b"
                                                                onClick={
                                                                    datosBaseListos
                                                                        ? this.abrirBusquedaAvanzada
                                                                        : () => message.info("Agregue los datos de venta primero")
                                                                }
                                                            >
                                                                Búsqueda avanzada
                                                            </ButtonItem>
                                                        </FormItem>
                                                        {!this.props.desactivarCargaExcelInsumosVentas && (
                                                        <FormItem noStyle>
                                                            <ButtonItem
                                                                style={{ marginTop: 10, marginBottom: 10, flexShrink: 0 }}
                                                                icon={<FileExcelOutlined />}
                                                                onClick={
                                                                    datosBaseListos
                                                                        ? () => this.setState({ modalCargarExcelVisible: true })
                                                                        : () =>
                                                                            message.info(
                                                                                "Agregue los datos de venta primero"
                                                                            )
                                                                }
                                                            >
                                                                Cargar Excel
                                                            </ButtonItem>
                                                        </FormItem>
                                                        )}
                                                        {this.props.formatoRequerimientoCotizaciones && (
                                                        <FormItem noStyle>
                                                            <ButtonItem
                                                                style={{ marginTop: 10, marginBottom: 10, flexShrink: 0 }}
                                                                icon={<DownloadOutlined />}
                                                                onClick={() => descargarFormatoRequerimiento(null)}
                                                            >
                                                                Formato vacío
                                                            </ButtonItem>
                                                        </FormItem>
                                                        )}
                                                        {this.props.formatoRequerimientoCotizaciones && (
                                                        <FormItem noStyle>
                                                            <ButtonItem
                                                                style={{ marginTop: 10, marginBottom: 10, flexShrink: 0 }}
                                                                icon={<UploadOutlined />}
                                                                onClick={
                                                                    datosBaseListos
                                                                        ? () => this.setState({ modalFormatoRequerimientoVisible: true })
                                                                        : () =>
                                                                            message.info(
                                                                                "Agregue los datos de venta primero"
                                                                            )
                                                                }
                                                            >
                                                                Subir formato
                                                            </ButtonItem>
                                                        </FormItem>
                                                        )}
                                                        </div>
                                                    );
                                                }}
                                            </FormItem>
                                        ),
                                    },
                                    {
                                        key: "entrega",
                                        label: "Entrega",
                                        customContent: this.renderEntregaContent()
                                    },
                                    // forceRender: sin el, si la pestaña no se abre sus campos no
                                    // se registran y onFinish no recibe los datos del formato.
                                    ...(this.props.formatoRequerimientoCotizaciones
                                        ? [{
                                            key: "requerimiento",
                                            label: "Requerimiento",
                                            forceRender: true,
                                            customContent: <TabFormatoRequerimiento todasInsumos={this.state.todasInsumos} />
                                        }]
                                        : [])
                                ]}
                                defaultActiveKey="tabla"
                                onTabChange={(key) => {
                                    if (key === "entrega") {
                                        this.consultarInformacionEntrega()
                                    }
                                }}

                                // Observaciones y Totales
                                observacionesConfig={(() => {
                                    return this.getObservacionesConfig();
                                })()}

                                // Botones de acción
                                actionButtons={
                                    <div style={{ display: "flex", justifyContent: "right" }}>
                                    <Space>
                                        <ButtonItem
                                       
                                            type="primary"
                                            hotkey="shift+c"
                                            rojoB
                                            onClick={this.atras.bind(this)}
                                        >
                                            Cancelar
                                        </ButtonItem>
                                        <ButtonItem
                                            hotkey="shift+a"
                                            type="primary"
                                            htmlType="submit"
                                            cyanB
                                        >
                                            Agregar
                                        </ButtonItem>
                                    </Space>
                                </div>
                                }
                            />
                                );
                            }}
                            </FormItem>
                        </Form>
                    </Spin>
                </div>
                <ModalItem
                    title="Confirmacion"
                    visible={this.state.modalConfirmacion}
                    onCancel={() => this.setState({ modalConfirmacion: false })}
                    onOk={() => {
                        this.setState({ modalConfirmacion: false });
                        this.onFinish(this.state.valuesForm);
                    }}
                    spinning={false}
                    footer
                >
                    <h1 style={{ textAlign: "center" }}>Desea continuar</h1>
                </ModalItem>
                <ElegirTipoDeCliente
                    visible={this.state.modalElegirTipoDeCliente}
                    id={this.state.modalElegirTipoDeClienteId}
                    nombre={this.state.modalElegirTipoDeClienteNombre}
                    cerrarElegirTipoDeCliente={this.cerrarElegirTipoDeCliente.bind(this)}
                />
                <MandarCorreoCotizacion
                    visible={this.state.modalCorreo}
                    id={this.state.modalCorreoId}
                    cerrarMandarCorreoCotizacion={this.cerrarMandarCorreoCotizacion.bind(this)}
                    history={this.props.history}
                />
                <ModalAutorizacion
                    visible={!!this.state.modalAutorizacion?.visible}
                    permisoId={this.state.modalAutorizacion?.permisoId}
                    contexto={this.state.modalAutorizacion?.contexto}
                    opcionesValor={this.state.objetoPrecios}
                    onAutorizado={this.onAutorizado}
                    onCancel={() => this.setState({ modalAutorizacion: null })}
                />
                <AgregarCliente
                    visible={this.state.modalAgregar}
                    cerrarModal={this.cerrarAgregarCliente}
                />
                <AgregarCanalVenta
                    visible={this.state.modalAgregarCanal}
                    cerrarModal={this.cerrarAgregarCanal}
                />
                {!this.props.desactivarCargaExcelInsumosVentas && (
                <ModalCargarExcelInsumos
                    visible={this.state.modalCargarExcelVisible}
                    onCancel={() => this.setState({ modalCargarExcelVisible: false })}
                    empresaId={this.props.empresaId}
                    headersToken={this.props.headersToken}
                    nombreDocumento="Cotizacion"
                    clienteId={this.formRef.current?.getFieldValue("clienteId")}
                    precioId={this.formRef.current?.getFieldValue("precioId")}
                    hayInsumosCapturados={(this.formRef.current?.getFieldValue("insumos") || []).length > 0}
                    cantidadInsumosCapturados={(this.formRef.current?.getFieldValue("insumos") || []).length}
                    permitirReemplazar
                    onConfirmar={this.cargarInsumosDesdeExcel}
                />
                )}
                {this.props.formatoRequerimientoCotizaciones && (
                <ModalFormatoRequerimiento
                    visible={this.state.modalFormatoRequerimientoVisible}
                    onCancel={() => this.setState({ modalFormatoRequerimientoVisible: false })}
                    empresaId={this.props.empresaId}
                    headersToken={this.props.headersToken}
                    clienteId={this.formRef.current?.getFieldValue("clienteId")}
                    precioId={this.formRef.current?.getFieldValue("precioId")}
                    hayInsumosCapturados={(this.formRef.current?.getFieldValue("insumos") || []).length > 0}
                    cantidadInsumosCapturados={(this.formRef.current?.getFieldValue("insumos") || []).length}
                    onConfirmar={this.cargarFormatoRequerimiento}
                />
                )}
                <ElegirLeyenda
                    visible={this.state.modalLeyenda}
                    cerrarElegirLeyenda={this.cerrarLeyenda.bind(this)}
                    leyenda={this.state.modalLeyendaLeyenda}
                    leyendasPasadas={this.state.modalLeyendaLeyendasPasadas}
                    clienteIdActual={this.state.clienteIdActual}
                    nombreClienteActual={this.state.nombreClienteActual}
                />
                <ElegirLotes
                    visible={this.state.modalElegirLotes}
                    cerrarElegirLotes={this.cerrarElegirLotes.bind(this)}
                    lotes={this.state.modalElegirLotesLotes}
                    insumoId={this.state.modalElegirLotesInsumoId}
                    proyectoId={this.state.modalElegirLotesProyectoId}
                    clienteId={this.state.modalElegirLotesClienteId}
                    cantidad={this.state.modalElegirLotesCantidad}
                />
                <ElegirAgrupaciones
                    visible={this.state.modalElegirAgrupaciones}
                    cerrarElegirAgrupaciones={this.cerrarElegirAgrupaciones.bind(this)}
                    agrupaciones={this.state.modalElegirAgrupacionesAgrupaciones}
                    insumoId={this.state.modalElegirAgrupacionesInsumoId}
                    proyectoId={this.state.modalElegirAgrupacionesProyectoId}
                    clienteId={this.state.modalElegirAgrupacionesClienteId}
                />
                <ElegirObservaciones
                    visible={this.state.modalObservaciones}
                    cerrarElegirObservaciones={this.cerrarObservaciones.bind(this)}
                    observaciones={this.state.modalObservacionesObservaciones}
                    observacionesPasadas={this.state.modalObservacionesObservacionesPasadas}
                    observacionesXml={this.state.modalObservacionesObservacionesXml}
                    clienteIdActual={this.state.clienteIdActual}
                    nombreClienteActual={this.state.nombreClienteActual}
                />
                <VerInsumo
                    visible={this.state.modalVerInsumo}
                    cerrarVerInsumo={(precio) => this.cerrarVerInsumo(precio)}
                    id={this.state.modalVerInsumoId}
                    precioId={this.state.modalVerInsumoPrecioId}
                    tipoDeCambio={this.state.modalVerInsumoTipoDeCambio}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                />
                <ModalCargarImagen
                    visible={this.state.modalImagenVisible}
                    alCerrar={this.cerrarModalImagen}
                    alGuardar={this.guardarImagenEnFormulario}
                    archivosIniciales={archivosFilaActual}
                    cantidadExistente={cantidadImagenesInsumo}
                    esInsumoCambio={esInsumoCambio}
                />
                <Modal
                    visible={this.state.modalVistaPreviaVisible}
                    footer={null}
                    onCancel={this.cerrarVistaPreviaInsumo}
                    width={600}
                    centered
                >
                    <div style={{ textAlign: 'center' }}>
                        {this.state.vistaPreviaUrl ? (
                            <img
                                src={this.state.vistaPreviaUrl}
                                alt="Vista previa"
                                style={{ maxWidth: '100%', maxHeight: '500px', objectFit: 'contain' }}
                            />
                        ) : (
                            <p>No se pudo cargar la imagen</p>
                        )}
                    </div>
                </Modal>
                <AgregarCirugia
                    visible={this.state.modalAgregarCirugia}
                    cerrarAgregarCirugia={this.cerrarAgregarCirugia.bind(this)}
                />
                <AgregarDoctor
                    visible={this.state.modalAgregarDoctor}
                    cerrarAgregarDoctor={this.cerrarAgregarDoctor.bind(this)}
                />
                <AgregarPaciente
                    visible={this.state.modalAgregarPaciente}
                    cerrarAgregarPaciente={this.cerrarAgregarPaciente.bind(this)}
                />
                <DetalleInsumoModal
                    visible={this.state.modalDetalleInsumoVisible}
                    onClose={this.cerrarDetalleInsumo}
                    insumoId={this.state.insumoSeleccionadoDetalle.id}
                    nombreInsumo={this.state.insumoSeleccionadoDetalle.nombre}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                />
                <DisponibilidadInsumoModal
                    visible={this.state.modalDisponibilidadVisible}
                    onClose={this.cerrarDisponibilidad}
                    insumoId={this.state.insumoSeleccionadoDisponibilidad.id}
                    nombreInsumo={this.state.insumoSeleccionadoDisponibilidad.nombre}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                    proyectoId={this.state.insumoSeleccionadoDisponibilidad.proyectoId}
                />
                <BusquedaAvanzadaInsumosModal
                    visible={this.state.modalBusquedaAvanzadaVisible}
                    onClose={this.cerrarBusquedaAvanzada}
                    onAgregar={this.agregarInsumoDesdeBusqueda}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                    {...this.state.contextoBusquedaAvanzada}
                />
                <HistorialInsumoClienteModal
                    visible={this.state.modalHistorialClienteVisible}
                    onClose={this.cerrarHistorialCliente}
                    insumoId={this.state.insumoSeleccionadoHistorial.id}
                    nombreInsumo={this.state.insumoSeleccionadoHistorial.nombre}
                    clienteId={this.state.insumoSeleccionadoHistorial.clienteId}
                    permitirUsarPrecio={!this.historialPrecioBloqueado()}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        insumosXClienteEmpresa: state.empresa.insumosXCliente,
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        autorizacionesRapidas: state.empresa.autorizacionesRapidas,
        taxidermia: state.empresa.taxidermia,
        usuarioId: state.user.usuarioId,
        certificada: state.empresa.certificada,
        equipoMedico: state.empresa.equipoMedico,
        complementoDetallista: state.empresa.complementoDetallista,
        quitarImpuestosOpcionalVentas: state.empresa.quitarImpuestosOpcionalVentas,
        desactivarCargaExcelInsumosVentas: state.empresa.desactivarCargaExcelInsumosVentas,
        formatoRequerimientoCotizaciones: state.empresa.formatoRequerimientoCotizaciones,
        escuela: state.empresa.escuela,
        permisoVenderCredito:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "68a0b80d4319162f78ce6419"
            )?.activado,
        permisoModificarMoneda:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "68a0b80d4319162f78ce641a"
            )?.activado,
        permisoModificarListaPrecios:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "68a0b80d4319162f78ce6420"
            )?.activado,
        permisoModificarPrecioUnitario:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "68a0b80d4319162f78ce642a"
            )?.activado,
        permisoModificarDescuento:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "68a0b80d4319162f78ce641c"
            )?.activado,
        permisoBloquearVendedorCotizacion:
            state.user.tipo !== 0 &&
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6a5d8651b6cc374e24fd22a2"
            )?.activado,
    };
};

export default connect(mapStateToProps)(AgregarCotizacion);